const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.8,115.18c97.48-48,197.73-110.75,311-85.07,35.11,8,67.06,27.87,88.66,56.81,57.76,77.39,53.06,195.92,21.68,283a158.11,158.11,0,0,1-15.79,32.55c-31.84,49.15-85.51,51.47-137.27,37.26-43.81-12-82.62-24.4-127.87-12.17-25.06,6.77-49.35,16.08-74.32,23.16-34,9.65-69,16.2-104.45,16.87-93.67,1.75-200.67-46-209-150.63a163.23,163.23,0,0,1-.33-20.39C35,254.84,48.79,213,87,191.34c38.46-21.8,84.09-30.42,125.23-45.88C235.66,136.67,258.36,126.23,280.8,115.18Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.8,115.18c97.48-48,197.73-110.75,311-85.07,35.11,8,67.06,27.87,88.66,56.81,57.76,77.39,53.06,195.92,21.68,283a158.11,158.11,0,0,1-15.79,32.55c-31.84,49.15-85.51,51.47-137.27,37.26-43.81-12-82.62-24.4-127.87-12.17-25.06,6.77-49.35,16.08-74.32,23.16-34,9.65-69,16.2-104.45,16.87-93.67,1.75-200.67-46-209-150.63a163.23,163.23,0,0,1-.33-20.39C35,254.84,48.79,213,87,191.34c38.46-21.8,84.09-30.42,125.23-45.88C235.66,136.67,258.36,126.23,280.8,115.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.54,453.75a.48.48,0,0,1-.45-.29.49.49,0,0,1,.24-.66L263.67,346.61a.49.49,0,0,1,.66.24.5.5,0,0,1-.24.67L33.75,453.71A.52.52,0,0,1,33.54,453.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703,453.75a.52.52,0,0,1-.21,0L472.48,347.52a.5.5,0,1,1,.42-.91L703.23,452.8a.5.5,0,0,1-.21.95Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.85,53.9h-108l.1-.59c.57-3.12,2.53-10.57,8.35-12.39s11.08,2.34,13,4.11c.37-3.23,2.17-12.83,10.51-16.1a14.6,14.6,0,0,1,15.86,3c1.17-2.83,6.15-12.44,19.9-12.44a22.07,22.07,0,0,1,16.3,6.8A27.41,27.41,0,0,1,289.26,45c1.95-.45,7.71-1.43,11.78,1.53a11.8,11.8,0,0,1,4.65,6.71Zm-106.8-1H304.54a10.85,10.85,0,0,0-4.08-5.52c-4.46-3.24-11.5-1.23-11.57-1.21l-.67.19,0-.69A26.36,26.36,0,0,0,281.18,27a21.11,21.11,0,0,0-15.58-6.5c-15.28,0-19.08,12-19.24,12.5l-.27.9-.59-.72a13.36,13.36,0,0,0-15.29-3.28c-9.43,3.69-10,16.14-10,16.26l0,1.2-.82-.87c-.07-.07-6.3-6.6-12.78-4.58C201.55,43.46,199.64,50.11,199.05,52.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.91,140.61H460.45l.11-.59c.45-2.45,2-8.31,6.59-9.74,4.37-1.37,8.44,1.61,10.09,3.07.32-2.73,1.77-9.88,8.25-12.42a11.47,11.47,0,0,1,12.36,2.24c1-2.4,5-9.62,15.55-9.62a17.29,17.29,0,0,1,12.79,5.34A21.48,21.48,0,0,1,532,133.45c1.64-.36,6-1,9.13,1.24a9.29,9.29,0,0,1,3.67,5.3Zm-83.25-1H543.6a8.37,8.37,0,0,0-3.09-4.11c-3.44-2.5-8.87-.94-8.92-.93l-.67.2,0-.69a20.39,20.39,0,0,0-5.47-14.5,16.35,16.35,0,0,0-12.07-5c-11.82,0-14.77,9.27-14.89,9.67l-.27.89-.59-.72a10.33,10.33,0,0,0-11.8-2.53c-7.28,2.85-7.69,12.49-7.7,12.59l0,1.2-.82-.88c-.05-.05-4.86-5.1-9.85-3.54C463.64,132.42,462.15,137.38,461.66,139.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4,86.05H36.94l.11-.59c.44-2.45,2-8.31,6.58-9.75,4.37-1.37,8.44,1.61,10.1,3.07.32-2.73,1.77-9.88,8.24-12.41A11.48,11.48,0,0,1,74.33,68.6c1-2.39,5-9.62,15.56-9.62a17.32,17.32,0,0,1,12.78,5.34,21.5,21.5,0,0,1,5.77,14.57c1.65-.36,6-1,9.14,1.24a9.33,9.33,0,0,1,3.66,5.29Zm-83.25-1h81.94a8.47,8.47,0,0,0-3.1-4.11c-3.44-2.5-8.87-.94-8.92-.93l-.67.2,0-.7A20.44,20.44,0,0,0,102,65a16.32,16.32,0,0,0-12.06-5C78.06,60,75.11,69.26,75,69.65l-.27.89-.6-.71A10.32,10.32,0,0,0,62.34,67.3c-7.29,2.85-7.7,12.49-7.7,12.58l0,1.2-.82-.87c-.05,0-4.87-5.1-9.84-3.54C40.12,77.86,38.63,82.81,38.15,85.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.68,102.48H558.36l.11-.59c.67-3.63,3.52-15.71,12.42-18.49s17.24,4.08,19.79,6.48c.41-4.24,2.81-19.51,15.75-24.58A21.78,21.78,0,0,1,630.35,70c1.45-3.69,8.71-19,29.94-19A33,33,0,0,1,684.7,61.23a41.14,41.14,0,0,1,11,28.46c2.53-.62,11.58-2.4,17.89,2.19a17.61,17.61,0,0,1,6.91,10Zm-161.11-1H719.39A16.67,16.67,0,0,0,713,92.69c-6.83-5-17.57-1.9-17.68-1.87l-.66.2,0-.7A40,40,0,0,0,684,61.92,32.09,32.09,0,0,0,660.29,52C637,52,631.08,70.9,631,71.09l-.27.89-.59-.72a20.78,20.78,0,0,0-23.36-5C592.41,71.86,591.6,90.82,591.59,91l0,1.2-.82-.88c-.1-.1-9.61-10.07-19.54-7C563.25,86.84,560.38,97.43,559.57,101.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--high-school-building--inject-54"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.55,
    y: 202.29,
    width: 730.9,
    height: 144.78,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.45,347.56H9.55a.5.5,0,0,1-.5-.5V202.29a.5.5,0,0,1,.5-.5h730.9a.5.5,0,0,1,.5.5V347.06A.5.5,0,0,1,740.45,347.56Zm-730.4-1H740V202.79H10.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.55,
    y: 290.85,
    width: 730.9,
    height: 56.22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.45,347.56H9.55a.5.5,0,0,1-.5-.5V290.85a.5.5,0,0,1,.5-.5h730.9a.5.5,0,0,1,.5.5v56.21A.5.5,0,0,1,740.45,347.56Zm-730.4-1H740V291.35H10.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.55,
    y: 202.29,
    width: 730.9,
    height: 12.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.45,214.82H9.55a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,.5-.5h730.9a.5.5,0,0,1,.5.5v12A.5.5,0,0,1,740.45,214.82Zm-730.4-1H740v-11H10.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.55,
    y: 190.16,
    width: 730.9,
    height: 17.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.45,208.23H9.55a.5.5,0,0,1-.5-.5V190.16a.5.5,0,0,1,.5-.5h730.9a.5.5,0,0,1,.5.5v17.57A.5.5,0,0,1,740.45,208.23Zm-730.4-1H740V190.66H10.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.83,
    y: 65.13,
    width: 180.33,
    height: 144.78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.17,210.41H284.83a.51.51,0,0,1-.5-.5V65.13a.51.51,0,0,1,.5-.5H465.17a.51.51,0,0,1,.5.5V209.91A.51.51,0,0,1,465.17,210.41Zm-179.84-1H464.67V65.63H285.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.87,152.78H427.4v-52h33.47a1.16,1.16,0,0,0,0-2.31H427.4V64.24a1.15,1.15,0,1,0-2.3,0V98.49H392V64.24a1.15,1.15,0,1,0-2.3,0V98.49h-33.1V64.24a1.16,1.16,0,1,0-2.31,0V98.49h-33.1V64.24a1.16,1.16,0,1,0-2.31,0V98.49H283.05a1.16,1.16,0,1,0,0,2.31h35.82v52H283.05a1.16,1.16,0,1,0,0,2.31h35.82v42.12a1.16,1.16,0,1,0,2.31,0V155.09h33.1v42.12a1.16,1.16,0,1,0,2.31,0V155.09h33.1v42.12a1.15,1.15,0,1,0,2.3,0V155.09H425.1v42.12a1.15,1.15,0,1,0,2.3,0V155.09h33.47a1.16,1.16,0,0,0,0-2.31Zm-139.69,0v-52h33.1v52Zm35.41,0v-52h33.1v52Zm35.4,0v-52H425.1v52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.25,198.87a1.66,1.66,0,0,1-1.65-1.66V155.59H392.49v41.62a1.65,1.65,0,1,1-3.3,0V155.59h-32.1v41.62a1.66,1.66,0,1,1-3.31,0V155.59h-32.1v41.62a1.66,1.66,0,1,1-3.31,0V155.59H283.05a1.66,1.66,0,1,1,0-3.31h35.32v-51H283.05a1.66,1.66,0,1,1,0-3.31h35.32V64.24a1.66,1.66,0,1,1,3.31,0V98h32.1V64.24a1.66,1.66,0,1,1,3.31,0V98h32.1V64.24a1.65,1.65,0,1,1,3.3,0V98H424.6V64.24a1.65,1.65,0,1,1,3.3,0V98h33a1.66,1.66,0,0,1,0,3.31h-33v51h33a1.66,1.66,0,0,1,0,3.31h-33v41.62A1.66,1.66,0,0,1,426.25,198.87ZM392,154.59H425.1a.5.5,0,0,1,.5.5v42.12a.65.65,0,1,0,1.3,0V155.09a.5.5,0,0,1,.5-.5h33.47a.65.65,0,0,0,.65-.65.66.66,0,0,0-.65-.66H427.4a.5.5,0,0,1-.5-.5v-52a.5.5,0,0,1,.5-.5h33.47a.66.66,0,0,0,0-1.31H427.4a.5.5,0,0,1-.5-.5V64.24a.65.65,0,1,0-1.3,0V98.49a.5.5,0,0,1-.5.5H392a.5.5,0,0,1-.5-.5V64.24a.65.65,0,1,0-1.3,0V98.49a.5.5,0,0,1-.5.5h-33.1a.5.5,0,0,1-.5-.5V64.24a.67.67,0,0,0-.66-.66.66.66,0,0,0-.65.66V98.49a.5.5,0,0,1-.5.5h-33.1a.5.5,0,0,1-.5-.5V64.24a.66.66,0,0,0-.65-.66.67.67,0,0,0-.66.66V98.49a.5.5,0,0,1-.5.5H283.05a.66.66,0,1,0,0,1.31h35.82a.5.5,0,0,1,.5.5v52a.5.5,0,0,1-.5.5H283.05a.67.67,0,0,0-.66.66.66.66,0,0,0,.66.65h35.82a.5.5,0,0,1,.5.5v42.12a.67.67,0,0,0,.66.66.66.66,0,0,0,.65-.66V155.09a.5.5,0,0,1,.5-.5h33.1a.5.5,0,0,1,.5.5v42.12a.66.66,0,0,0,.65.66.67.67,0,0,0,.66-.66V155.09a.5.5,0,0,1,.5-.5h33.1a.5.5,0,0,1,.5.5v42.12a.65.65,0,1,0,1.3,0V155.09A.5.5,0,0,1,392,154.59Zm33.11-1.31H392a.5.5,0,0,1-.5-.5v-52a.5.5,0,0,1,.5-.5H425.1a.5.5,0,0,1,.5.5v52A.5.5,0,0,1,425.1,153.28Zm-32.61-1H424.6v-51H392.49Zm-2.8,1h-33.1a.5.5,0,0,1-.5-.5v-52a.5.5,0,0,1,.5-.5h33.1a.5.5,0,0,1,.5.5v52A.5.5,0,0,1,389.69,153.28Zm-32.6-1h32.1v-51h-32.1Zm-2.81,1h-33.1a.5.5,0,0,1-.5-.5v-52a.5.5,0,0,1,.5-.5h33.1a.5.5,0,0,1,.5.5v52A.5.5,0,0,1,354.28,153.28Zm-32.6-1h32.1v-51h-32.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.13,
    y: 72.75,
    width: 19.68,
    height: 137.16,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,210.41H272.13a.51.51,0,0,1-.5-.5V72.75a.51.51,0,0,1,.5-.5h19.69a.51.51,0,0,1,.5.5V209.91A.51.51,0,0,1,291.82,210.41Zm-19.19-1h18.69V73.25H272.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.88,
    y: 75.93,
    width: 36.19,
    height: 10.16,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.07,86.59H263.88a.5.5,0,0,1-.5-.5V75.93a.5.5,0,0,1,.5-.5h36.19a.5.5,0,0,1,.5.5V86.09A.5.5,0,0,1,300.07,86.59Zm-35.69-1h35.19V76.43H264.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.2,
    y: 72.75,
    width: 19.68,
    height: 137.16,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.88,210.41H451.2a.5.5,0,0,1-.5-.5V72.75a.5.5,0,0,1,.5-.5h19.68a.5.5,0,0,1,.5.5V209.91A.5.5,0,0,1,470.88,210.41Zm-19.18-1h18.68V73.25H451.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.94,
    y: 75.93,
    width: 36.19,
    height: 10.16,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.14,86.59h-36.2a.51.51,0,0,1-.5-.5V75.93a.5.5,0,0,1,.5-.5h36.2a.5.5,0,0,1,.5.5V86.09A.51.51,0,0,1,479.14,86.59Zm-35.7-1h35.2V76.43h-35.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.31,87.36a429.52,429.52,0,0,0-226.69,0c-1.78-6.54-3.57-15.13-5.36-21.66a449.83,449.83,0,0,1,237.41,0C485.89,72.23,484.1,80.82,482.31,87.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,87.86a.5.5,0,0,1-.48-.37c-.9-3.28-1.81-7.13-2.69-10.85s-1.78-7.56-2.67-10.81a.51.51,0,0,1,.35-.62,450.84,450.84,0,0,1,237.68,0,.54.54,0,0,1,.3.24.55.55,0,0,1,.05.38c-.9,3.26-1.81,7.1-2.68,10.82s-1.79,7.57-2.69,10.84a.47.47,0,0,1-.23.3.5.5,0,0,1-.38,0,429.33,429.33,0,0,0-226.42,0Zm-4.74-21.81c.85,3.16,1.71,6.82,2.55,10.36s1.7,7.18,2.55,10.33a430.36,430.36,0,0,1,226,0c.85-3.15,1.71-6.79,2.54-10.32s1.71-7.2,2.56-10.37A449.55,449.55,0,0,0,250.88,66.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.83,
    y: 202.29,
    width: 180.33,
    height: 144.78,
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.17,347.56H284.83a.5.5,0,0,1-.5-.5V202.29a.5.5,0,0,1,.5-.5H465.17a.5.5,0,0,1,.5.5V347.06A.5.5,0,0,1,465.17,347.56Zm-179.84-1H464.67V202.79H285.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.85,
    y: 255.44,
    width: 104.3,
    height: 91.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.15,347.56H322.85a.5.5,0,0,1-.5-.5V255.44a.5.5,0,0,1,.5-.5h104.3a.5.5,0,0,1,.5.5v91.62A.5.5,0,0,1,427.15,347.56Zm-103.8-1h103.3V255.94H323.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.85,
    y: 204,
    width: 104.3,
    height: 48.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.15,252.82H322.85a.51.51,0,0,1-.5-.5V204a.51.51,0,0,1,.5-.5h104.3a.51.51,0,0,1,.5.5v48.32A.51.51,0,0,1,427.15,252.82Zm-103.8-1h103.3V204.5H323.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.13,
    y: 209.91,
    width: 19.68,
    height: 137.16,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,347.56H272.13a.5.5,0,0,1-.5-.5V209.91a.5.5,0,0,1,.5-.5h19.69a.5.5,0,0,1,.5.5V347.06A.5.5,0,0,1,291.82,347.56Zm-19.19-1h18.69V210.41H272.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.88,
    y: 213.08,
    width: 36.19,
    height: 10.16,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.07,223.74H263.88a.5.5,0,0,1-.5-.5V213.08a.5.5,0,0,1,.5-.5h36.19a.5.5,0,0,1,.5.5v10.16A.5.5,0,0,1,300.07,223.74Zm-35.69-1h35.19v-9.16H264.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.2,
    y: 209.91,
    width: 19.68,
    height: 137.16,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.88,347.56H451.2a.5.5,0,0,1-.5-.5V209.91a.5.5,0,0,1,.5-.5h19.68a.5.5,0,0,1,.5.5V347.06A.5.5,0,0,1,470.88,347.56Zm-19.18-1h18.68V210.41H451.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.94,
    y: 213.08,
    width: 36.19,
    height: 10.16,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.14,223.74h-36.2a.5.5,0,0,1-.5-.5V213.08a.51.51,0,0,1,.5-.5h36.2a.51.51,0,0,1,.5.5v10.16A.5.5,0,0,1,479.14,223.74Zm-35.7-1h35.2v-9.16h-35.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.31,224.51a429.52,429.52,0,0,0-226.69,0c-1.78-6.53-3.57-15.13-5.36-21.66a449.83,449.83,0,0,1,237.41,0C485.89,209.38,484.1,218,482.31,224.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,225a.49.49,0,0,1-.48-.37c-.9-3.27-1.81-7.12-2.69-10.85s-1.78-7.55-2.67-10.81a.5.5,0,0,1,.35-.61,450.63,450.63,0,0,1,237.68,0,.52.52,0,0,1,.3.23.57.57,0,0,1,.05.38c-.9,3.27-1.81,7.11-2.68,10.83s-1.79,7.56-2.69,10.83a.52.52,0,0,1-.23.31.5.5,0,0,1-.38,0,429.33,429.33,0,0,0-226.42,0A.34.34,0,0,1,255.62,225Zm-4.74-21.81c.85,3.17,1.71,6.82,2.55,10.36s1.7,7.19,2.55,10.34a430.36,430.36,0,0,1,226,0c.85-3.15,1.71-6.79,2.54-10.32s1.71-7.21,2.56-10.38A449.75,449.75,0,0,0,250.88,203.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.31,85.3a429.52,429.52,0,0,0-226.69,0q-2.67-9.81-5.36-19.6a449.83,449.83,0,0,1,237.41,0Q485,75.5,482.31,85.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,85.79a.49.49,0,0,1-.48-.36l-5.36-19.6a.51.51,0,0,1,.35-.62,450.84,450.84,0,0,1,237.68,0,.54.54,0,0,1,.3.24.55.55,0,0,1,.05.38l-5.37,19.6a.52.52,0,0,1-.23.3.55.55,0,0,1-.38,0,429.33,429.33,0,0,0-226.42,0ZM369,69.58a430,430,0,0,1,113,15.1l5.1-18.63a449.55,449.55,0,0,0-236.18,0L256,84.68A430,430,0,0,1,369,69.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.31,222.45a429.52,429.52,0,0,0-226.69,0q-2.67-9.8-5.36-19.6a449.83,449.83,0,0,1,237.41,0Q485,212.65,482.31,222.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,223a.49.49,0,0,1-.48-.37L249.78,203a.5.5,0,0,1,.35-.61,450.63,450.63,0,0,1,237.68,0,.52.52,0,0,1,.3.23.57.57,0,0,1,.05.38l-5.37,19.6a.52.52,0,0,1-.23.31.5.5,0,0,1-.38,0,429.33,429.33,0,0,0-226.42,0A.34.34,0,0,1,255.62,223ZM369,206.74a430,430,0,0,1,113,15.1l5.1-18.64a449.75,449.75,0,0,0-236.18,0L256,221.84A430,430,0,0,1,369,206.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.55,
    y: 265.15,
    width: 21.59,
    height: 76.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.14,342.48H330.55a.5.5,0,0,1-.5-.5V265.15a.51.51,0,0,1,.5-.5h21.59a.5.5,0,0,1,.5.5V342A.5.5,0,0,1,352.14,342.48Zm-21.09-1h20.59V265.65H331.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.57,
    y: 265.15,
    width: 21.59,
    height: 76.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.16,342.48H363.57a.5.5,0,0,1-.5-.5V265.15a.5.5,0,0,1,.5-.5h21.59a.5.5,0,0,1,.5.5V342A.5.5,0,0,1,385.16,342.48Zm-21.09-1h20.59V265.65H364.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 265.15,
    width: 21.59,
    height: 76.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,342.48H396.59a.5.5,0,0,1-.5-.5V265.15a.5.5,0,0,1,.5-.5h21.59a.5.5,0,0,1,.5.5V342A.5.5,0,0,1,418.18,342.48Zm-21.09-1h20.59V265.65H397.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.2,
    y: 305.79,
    width: 101.6,
    height: 3.81,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.8,310.1H324.2a.5.5,0,0,1-.5-.5v-3.81a.5.5,0,0,1,.5-.5H425.8a.5.5,0,0,1,.5.5v3.81A.5.5,0,0,1,425.8,310.1Zm-101.1-1H425.3v-2.81H324.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.88,
    y: 328.61,
    width: 31.87,
    height: 18.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.75,347.56H263.88a.5.5,0,0,1-.5-.5V328.61a.5.5,0,0,1,.5-.5h31.87a.5.5,0,0,1,.5.5v18.45A.5.5,0,0,1,295.75,347.56Zm-31.37-1h30.87V329.11H264.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.26,
    y: 328.61,
    width: 31.87,
    height: 18.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.14,347.56H447.26a.5.5,0,0,1-.5-.5V328.61a.51.51,0,0,1,.5-.5h31.88a.51.51,0,0,1,.5.5v18.45A.5.5,0,0,1,479.14,347.56Zm-31.38-1h30.88V329.11H447.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.36,
    y: 235.46,
    width: 75.36,
    height: 71.03,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.72,307H144.36a.5.5,0,0,1-.5-.5v-71a.5.5,0,0,1,.5-.5h75.36a.51.51,0,0,1,.5.5v71A.5.5,0,0,1,219.72,307Zm-74.86-1h74.36V236H144.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.36,
    y: 287.02,
    width: 75.36,
    height: 3.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.72,291H144.36a.5.5,0,0,1-.5-.5V287a.5.5,0,0,1,.5-.5h75.36a.51.51,0,0,1,.5.5v3.51A.5.5,0,0,1,219.72,291Zm-74.86-1h74.36v-2.51H144.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.37,
    y: 235.46,
    width: 7.34,
    height: 71.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71,307h-7.34a.5.5,0,0,1-.5-.5v-71a.5.5,0,0,1,.5-.5h7.34a.51.51,0,0,1,.5.5v71A.5.5,0,0,1,185.71,307Zm-6.84-1h6.34V236h-6.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.28,
    y: 235.46,
    width: 75.36,
    height: 71.03,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.64,307H41.28a.5.5,0,0,1-.5-.5v-71a.5.5,0,0,1,.5-.5h75.36a.5.5,0,0,1,.5.5v71A.5.5,0,0,1,116.64,307Zm-74.86-1h74.36V236H41.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.28,
    y: 287.02,
    width: 75.36,
    height: 3.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.64,291H41.28a.5.5,0,0,1-.5-.5V287a.5.5,0,0,1,.5-.5h75.36a.5.5,0,0,1,.5.5v3.51A.5.5,0,0,1,116.64,291Zm-74.86-1h74.36v-2.51H41.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.29,
    y: 235.46,
    width: 7.34,
    height: 71.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63,307H75.29a.5.5,0,0,1-.5-.5v-71a.5.5,0,0,1,.5-.5h7.34a.51.51,0,0,1,.5.5v71A.5.5,0,0,1,82.63,307Zm-6.84-1h6.34V236H75.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.57,
    y: 235.46,
    width: 75.36,
    height: 71.03,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.93,307H628.57a.5.5,0,0,1-.5-.5v-71a.51.51,0,0,1,.5-.5h75.36a.5.5,0,0,1,.5.5v71A.5.5,0,0,1,703.93,307Zm-74.86-1h74.36V236H629.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.57,
    y: 287.02,
    width: 75.36,
    height: 3.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.93,291H628.57a.5.5,0,0,1-.5-.5V287a.51.51,0,0,1,.5-.5h75.36a.5.5,0,0,1,.5.5v3.51A.5.5,0,0,1,703.93,291Zm-74.86-1h74.36v-2.51H629.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.59,
    y: 235.46,
    width: 7.34,
    height: 71.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.92,307h-7.33a.5.5,0,0,1-.5-.5v-71a.5.5,0,0,1,.5-.5h7.33a.5.5,0,0,1,.5.5v71A.5.5,0,0,1,669.92,307Zm-6.83-1h6.33V236h-6.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.49,
    y: 235.46,
    width: 75.36,
    height: 71.03,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.85,307H525.49a.5.5,0,0,1-.5-.5v-71a.51.51,0,0,1,.5-.5h75.36a.5.5,0,0,1,.5.5v71A.5.5,0,0,1,600.85,307ZM526,306h74.36V236H526Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.49,
    y: 287.02,
    width: 75.36,
    height: 3.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.85,291H525.49a.5.5,0,0,1-.5-.5V287a.51.51,0,0,1,.5-.5h75.36a.5.5,0,0,1,.5.5v3.51A.5.5,0,0,1,600.85,291ZM526,290h74.36v-2.51H526Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.51,
    y: 235.46,
    width: 7.34,
    height: 71.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.84,307h-7.33a.5.5,0,0,1-.5-.5v-71a.5.5,0,0,1,.5-.5h7.33a.5.5,0,0,1,.5.5v71A.5.5,0,0,1,566.84,307ZM560,306h6.33V236H560Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.64,207.16q-1-6.6-2-13.21l3.21-.42c.25,1.79.5,3.57.74,5.36l2.21-.27c-.24-1.79-.47-3.58-.71-5.36l3.23-.38q.82,6.63,1.64,13.25l-3.11.36c-.26-1.93-.51-3.85-.77-5.78l-2.19.27c.27,1.93.54,3.85.8,5.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.13,205.9q-.78-6.63-1.55-13.26c1.07-.12,2.15-.22,3.22-.33q.7,6.65,1.42,13.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,205.27a4,4,0,0,1-2.35-.38,3.13,3.13,0,0,1-1.35-1.51,7.35,7.35,0,0,1-.6-2.37l-.45-4.46a6.84,6.84,0,0,1,.14-2.48,3.13,3.13,0,0,1,1.2-1.72,5.14,5.14,0,0,1,2.57-.78,5.31,5.31,0,0,1,2.59.3,2.84,2.84,0,0,1,1.43,1.27,4.88,4.88,0,0,1,.55,2l.06.85-3.11.23-.09-1.09a5.76,5.76,0,0,0-.13-.78,1.07,1.07,0,0,0-.34-.56,1,1,0,0,0-.74-.16.94.94,0,0,0-.73.31,1.2,1.2,0,0,0-.24.66,4.19,4.19,0,0,0,0,.79c.19,2,.37,4.1.56,6.15a4,4,0,0,0,.17.82,1.24,1.24,0,0,0,.41.6,1.24,1.24,0,0,0,1.47-.13,1.31,1.31,0,0,0,.31-.66,3.4,3.4,0,0,0,0-.85l-.14-1.56-1.28.1-.15-1.72,4.14-.31q.26,3.45.52,6.9l-2.05.15c-.08-.37-.17-.73-.26-1.09a2.4,2.4,0,0,1-.74,1A2.57,2.57,0,0,1,341,205.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.44,204.61q-.46-6.66-.92-13.31l3.23-.19c.1,1.8.21,3.59.32,5.39l2.22-.11c-.1-1.8-.19-3.6-.29-5.4l3.25-.14.58,13.33-3.12.14q-.16-2.91-.31-5.82l-2.21.11.35,5.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,204.13a4.93,4.93,0,0,1-2.21-.42,2.92,2.92,0,0,1-1.36-1.35A6,6,0,0,1,362,200l2.68-.43a5.87,5.87,0,0,0,.19,1.38,1.56,1.56,0,0,0,.43.75,1,1,0,0,0,.66.23c.33,0,.54-.11.63-.32a1.52,1.52,0,0,0,.15-.66,2.28,2.28,0,0,0-.44-1.39,6,6,0,0,0-1.16-1.13l-1.25-1a6.82,6.82,0,0,1-1.41-1.43,3.47,3.47,0,0,1-.6-2,3.11,3.11,0,0,1,1-2.61,4.6,4.6,0,0,1,3-.95,4.19,4.19,0,0,1,1.89.35,2.74,2.74,0,0,1,1.09.94,3.7,3.7,0,0,1,.51,1.24,7,7,0,0,1,.15,1.24l-2.75.33a7.18,7.18,0,0,0-.09-1,1.22,1.22,0,0,0-.27-.67.82.82,0,0,0-1.26.12,1.29,1.29,0,0,0-.19.69,1.82,1.82,0,0,0,.4,1.21,7.92,7.92,0,0,0,1,1l1.2,1a7.6,7.6,0,0,1,1.59,1.67,4,4,0,0,1,.65,2.33,3.24,3.24,0,0,1-1.73,2.92A4.1,4.1,0,0,1,366.13,204.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.34,204.15a5.1,5.1,0,0,1-2.52-.58,3.1,3.1,0,0,1-1.3-1.56,6.69,6.69,0,0,1-.38-2.35c0-1.6,0-3.21,0-4.81a6.5,6.5,0,0,1,.41-2.38,3,3,0,0,1,1.37-1.53,5.2,5.2,0,0,1,2.63-.51,5.29,5.29,0,0,1,2.53.53,2.76,2.76,0,0,1,1.25,1.39,5.14,5.14,0,0,1,.32,2c0,.38,0,.76,0,1.15l-3.11-.07,0-1.33c0-.27,0-.52,0-.76a1.12,1.12,0,0,0-.25-.61,1.24,1.24,0,0,0-1.48,0,1.13,1.13,0,0,0-.32.61,4.92,4.92,0,0,0-.07.78q0,3.15-.08,6.28a4.21,4.21,0,0,0,.06.82,1.16,1.16,0,0,0,.31.59,1,1,0,0,0,.69.23.89.89,0,0,0,.7-.22,1.18,1.18,0,0,0,.27-.62,4.9,4.9,0,0,0,.07-.77l0-1.4,3.08.07,0,1.15a5.4,5.4,0,0,1-.42,2,2.83,2.83,0,0,1-1.27,1.38A4.91,4.91,0,0,1,375.34,204.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.14,204.08q.23-6.66.46-13.33l3.23.11-.24,5.4,2.22.09c.09-1.79.18-3.59.28-5.39l3.24.16q-.39,6.66-.8,13.32l-3.12-.15.3-5.83-2.21-.09c-.09,1.94-.17,3.88-.26,5.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67,205a5.17,5.17,0,0,1-2.46-.7,3,3,0,0,1-1.21-1.59,6.15,6.15,0,0,1-.25-2.38l.33-5a6,6,0,0,1,.57-2.32,3,3,0,0,1,1.46-1.41,5.61,5.61,0,0,1,2.64-.34,5.46,5.46,0,0,1,2.58.72,3,3,0,0,1,1.24,1.59,6,6,0,0,1,.19,2.39l-.45,4.94a6.41,6.41,0,0,1-.62,2.31,3,3,0,0,1-1.46,1.4A5.31,5.31,0,0,1,395.67,205Zm.16-2.09a.94.94,0,0,0,.73-.18,1.11,1.11,0,0,0,.35-.57,3.48,3.48,0,0,0,.13-.73l.53-6.4a3.83,3.83,0,0,0,0-.76,1.1,1.1,0,0,0-.26-.6,1,1,0,0,0-.72-.29,1,1,0,0,0-.71.18,1.08,1.08,0,0,0-.35.57,3.47,3.47,0,0,0-.13.74q-.24,3.19-.49,6.41a6.06,6.06,0,0,0,0,.74,1.1,1.1,0,0,0,.23.61A.92.92,0,0,0,395.83,202.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.8,205.9a5.13,5.13,0,0,1-2.44-.77,3,3,0,0,1-1.16-1.63,6,6,0,0,1-.17-2.38l.48-4.93a6,6,0,0,1,.64-2.31,3,3,0,0,1,1.51-1.36,5.38,5.38,0,0,1,2.65-.27,5.49,5.49,0,0,1,2.55.79,3,3,0,0,1,1.2,1.63,6.14,6.14,0,0,1,.12,2.39c-.21,1.64-.41,3.28-.61,4.92a6.3,6.3,0,0,1-.69,2.29,3.1,3.1,0,0,1-1.51,1.37A5.22,5.22,0,0,1,405.8,205.9Zm.23-2.08a1,1,0,0,0,.74-.16,1.24,1.24,0,0,0,.36-.56,4.29,4.29,0,0,0,.15-.73L408,196a3.78,3.78,0,0,0,0-.75,1.13,1.13,0,0,0-.23-.61,1,1,0,0,0-.71-.3,1,1,0,0,0-.72.16,1,1,0,0,0-.37.55,4,4,0,0,0-.15.74l-.69,6.39a4.61,4.61,0,0,0,0,.74,1.13,1.13,0,0,0,.22.62A.91.91,0,0,0,406,203.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.93,206.37q.85-6.63,1.72-13.25l3.21.4q-.78,5.63-1.57,11.25c1.08.13,2.15.28,3.23.42l-.3,2C416.13,206.88,414,206.61,411.93,206.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.73,50.85c-53.41.09-96.67,41.21-96.67,91.92v.76a49.61,49.61,0,0,0,50.76,49.06,72.75,72.75,0,0,1,13.42.85c9.14,1.48,16.22,6.84,21,13a14,14,0,0,0,11,5.61h1a14,14,0,0,0,11-5.61c4.79-6.19,11.87-11.55,21-13a72.75,72.75,0,0,1,13.42-.85,49.61,49.61,0,0,0,50.76-49.06v-.76C227.39,92.06,184.13,50.94,130.73,50.85Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73,50.85c-53.41.09-96.67,41.21-96.67,91.92v.76a49.61,49.61,0,0,0,50.76,49.06,72.75,72.75,0,0,1,13.42.85c9.14,1.48,16.22,6.84,21,13a14,14,0,0,0,11,5.61h1a14,14,0,0,0,11-5.61c4.79-6.19,11.87-11.55,21-13a72.75,72.75,0,0,1,13.42-.85,49.61,49.61,0,0,0,50.76-49.06v-.76C227.39,92.06,184.13,50.94,130.73,50.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,131.61s-1.92-5.46-6-7.37a33.11,33.11,0,0,0-6.83-2.46S103.34,133,114,131.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.93,117.09s-.31-5.78-3.71-8.75a33.47,33.47,0,0,0-5.88-4.26S108.32,115.44,118.93,117.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.45,161.33s-3.67-4.47-8.17-4.87a33.83,33.83,0,0,0-7.26,0S154.91,166.26,164.45,161.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8,172.06s-3.66-4.48-8.16-4.87a33,33,0,0,0-7.26,0S174.26,177,183.8,172.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.93,160s3.67-4.48,8.17-4.88a33.83,33.83,0,0,1,7.26,0S102.47,164.89,92.93,160Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,168.13s3.66-4.48,8.17-4.87a33.4,33.4,0,0,1,7.25,0S75.47,173.06,65.93,168.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,112.18s-.31-5.78-3.72-8.76a33.91,33.91,0,0,0-5.87-4.26S92.21,110.52,102.82,112.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,92.89s-.32-5.77-3.72-8.75a33.23,33.23,0,0,0-5.87-4.26S76.43,91.24,87,92.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,115.45s.32-5.77,3.72-8.75a33.23,33.23,0,0,1,5.87-4.26S167,113.8,156.34,115.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.81,104.78s.32-5.78,3.72-8.76a33.91,33.91,0,0,1,5.87-4.26S186.42,103.12,175.81,104.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.7,108s3.33-4.73,2.51-9.17a33.53,33.53,0,0,0-2-7S122.4,100.14,129.7,108Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.41,129.77s.55-5.76-2.38-9.2a33.39,33.39,0,0,0-5.18-5.09S123.17,126.57,133.41,129.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.67,103.46s1.73-5.53-.42-9.51a33.39,33.39,0,0,0-4-6S110.31,98.19,119.67,103.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.67,81.48S121.4,76,119.25,72a32.92,32.92,0,0,0-4-6S110.31,76.21,119.67,81.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,146.33s1.73-5.52-.42-9.5a33.28,33.28,0,0,0-4-6.05S114.68,141.07,124,146.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,139.84s4.89-3.09,5.83-7.52a34,34,0,0,0,.85-7.2S133.24,129.78,137,139.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56,103.46s-1.72-5.53.42-9.51a34,34,0,0,1,4-6S146.92,98.19,137.56,103.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.76,84.85s-1.73-5.52.41-9.5a33.94,33.94,0,0,1,4-6S165.11,79.58,155.76,84.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.38,117.34s4.87-3.12,5.79-7.54a33.36,33.36,0,0,0,.82-7.21S140.6,107.29,144.38,117.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.53,132.46s5.6-1.45,7.84-5.37a33.59,33.59,0,0,0,3-6.6S157.05,121.74,157.53,132.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.79,146s5.25,2.43,9.47.81a33.11,33.11,0,0,0,6.51-3.2S165.21,137.37,158.79,146Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,133.68s5.25,2.43,9.47.81a33,33,0,0,0,6.52-3.2S172.58,125.08,166.16,133.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.4,134.83s5.26,2.42,9.48.81a33.82,33.82,0,0,0,6.51-3.2S195.82,126.22,189.4,134.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6,141.53s3.53,4.59,8,5.12a33.43,33.43,0,0,0,7.25.19S102.28,136.89,92.6,141.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.13,125.7s3.53,4.58,8,5.11a33.43,33.43,0,0,0,7.25.19S90.81,121.05,81.13,125.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.12,122.56s3.53,4.58,8,5.11a33.54,33.54,0,0,0,7.26.19S63.81,117.91,54.12,122.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.16 163.81 142.78 168.44 168.3 136.65 133.45 169.13 133.24 171.38 131.68 137.24 129.22 191.17 94.86 159.14 120.38 190.93 98.99 186.31 126.02 197.97 128.75 201.37 124 379.81 139.36 379.81 133.62 179.85 137.13 175.47 164.16 163.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.39,113.93c-42.26.07-76.49,32.61-76.49,72.74v.6a39.25,39.25,0,0,0,40.17,38.82,57.83,57.83,0,0,1,10.62.68,26.45,26.45,0,0,1,16.62,10.31,11.08,11.08,0,0,0,8.68,4.43h.81a11.08,11.08,0,0,0,8.67-4.43,26.5,26.5,0,0,1,16.63-10.31,57.83,57.83,0,0,1,10.62-.68,39.26,39.26,0,0,0,40.17-38.82v-.6C679.89,146.54,645.65,114,603.39,113.93Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.39,113.93c-42.26.07-76.49,32.61-76.49,72.74v.6a39.25,39.25,0,0,0,40.17,38.82,57.83,57.83,0,0,1,10.62.68,26.45,26.45,0,0,1,16.62,10.31,11.08,11.08,0,0,0,8.68,4.43h.81a11.08,11.08,0,0,0,8.67-4.43,26.5,26.5,0,0,1,16.63-10.31,57.83,57.83,0,0,1,10.62-.68,39.26,39.26,0,0,0,40.17-38.82v-.6C679.89,146.54,645.65,114,603.39,113.93Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.15,177.84s-1.52-4.33-4.76-5.84a26.5,26.5,0,0,0-5.4-1.94S581.72,178.92,590.15,177.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.06,166.35s-.25-4.57-2.94-6.93a26,26,0,0,0-4.65-3.37S585.67,165,594.06,166.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.08,201.36s-2.9-3.55-6.46-3.86a26.87,26.87,0,0,0-5.75,0S622.53,205.26,630.08,201.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.4,209.85s-2.9-3.55-6.47-3.86a26.79,26.79,0,0,0-5.74,0S637.85,213.75,645.4,209.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.49,200.28s2.9-3.55,6.46-3.86a26.79,26.79,0,0,1,5.74,0S581,204.17,573.49,200.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.12,206.74s2.9-3.55,6.46-3.86a26.79,26.79,0,0,1,5.74,0S559.67,210.64,552.12,206.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.31,162.46s-.25-4.57-2.94-6.93a26,26,0,0,0-4.65-3.37S572.92,161.15,581.31,162.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.82,147.2s-.25-4.57-2.94-6.93a26,26,0,0,0-4.65-3.37S560.43,145.89,568.82,147.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.67,165.05s.25-4.57,2.94-6.93a26.88,26.88,0,0,1,4.64-3.37S632.06,163.74,623.67,165.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.07,156.6s.25-4.57,2.94-6.93a27.13,27.13,0,0,1,4.65-3.37S647.47,155.29,639.07,156.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.58,159.17s2.64-3.74,2-7.26a26.66,26.66,0,0,0-1.55-5.53S596.81,152.93,602.58,159.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.52,176.38s.43-4.56-1.88-7.28a27,27,0,0,0-4.1-4S597.41,173.85,605.52,176.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.64,155.56s1.37-4.37-.33-7.52a26.29,26.29,0,0,0-3.17-4.79S587.24,151.39,594.64,155.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.64,138.16s1.37-4.37-.33-7.52a25.93,25.93,0,0,0-3.17-4.78S587.24,134,594.64,138.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.1,189.48s1.37-4.37-.33-7.51a26.29,26.29,0,0,0-3.17-4.79S590.7,185.32,598.1,189.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.35,184.35s3.86-2.45,4.6-5.95a27,27,0,0,0,.68-5.7S605.39,176.39,608.35,184.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.81,155.56s-1.37-4.37.32-7.52a26.59,26.59,0,0,1,3.18-4.79S616.21,151.39,608.81,155.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.2,140.83s-1.37-4.37.33-7.52a26.57,26.57,0,0,1,3.17-4.78S630.61,136.67,623.2,140.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.2,166.54s3.86-2.46,4.58-6a26.35,26.35,0,0,0,.65-5.71S611.21,158.59,614.2,166.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.6,178.51s4.44-1.15,6.21-4.25A26.65,26.65,0,0,0,633.2,169S624.23,170,624.6,178.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.6,189.2s4.16,1.92,7.5.64a26.64,26.64,0,0,0,5.15-2.53S630.68,182.39,625.6,189.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.43,179.48s4.16,1.92,7.5.64a27,27,0,0,0,5.16-2.53S636.52,172.67,631.43,179.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.83,180.38s4.15,1.92,7.5.64a26.64,26.64,0,0,0,5.15-2.53S654.91,173.57,649.83,180.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.22,185.69s2.8,3.63,6.35,4.05a27.26,27.26,0,0,0,5.74.15S580.88,182,573.22,185.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.15,173.16s2.79,3.62,6.34,4a26.43,26.43,0,0,0,5.74.15S571.81,169.48,564.15,173.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.78,170.67s2.79,3.63,6.34,4.05a26.43,26.43,0,0,0,5.74.15S550.44,167,542.78,170.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.86 203.32 612.93 206.98 633.13 181.82 605.55 207.53 605.38 209.31 604.15 182.29 602.2 224.97 575.01 199.62 595.2 224.78 578.28 221.12 599.67 230.35 601.83 233.04 598.07 374.25 610.22 374.25 605.69 216.01 608.46 212.55 629.86 203.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.35,217.87c-25.39,0-46,19.59-46,43.69v.37a23.58,23.58,0,0,0,24.13,23.32,35,35,0,0,1,6.38.4,15.91,15.91,0,0,1,10,6.2,6.65,6.65,0,0,0,5.21,2.66h.48a6.65,6.65,0,0,0,5.21-2.66,15.91,15.91,0,0,1,10-6.2,35,35,0,0,1,6.38-.4,23.58,23.58,0,0,0,24.13-23.32v-.37C737.3,237.46,716.74,217.91,691.35,217.87Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.35,217.87c-25.39,0-46,19.59-46,43.69v.37a23.58,23.58,0,0,0,24.13,23.32,35,35,0,0,1,6.38.4,15.91,15.91,0,0,1,10,6.2,6.65,6.65,0,0,0,5.21,2.66h.48a6.65,6.65,0,0,0,5.21-2.66,15.91,15.91,0,0,1,10-6.2,35,35,0,0,1,6.38-.4,23.58,23.58,0,0,0,24.13-23.32v-.37C737.3,237.46,716.74,217.91,691.35,217.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.39,256.26s-.91-2.6-2.85-3.51a16.25,16.25,0,0,0-3.25-1.16S678.33,256.91,683.39,256.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.74,249.36s-.15-2.75-1.76-4.16a16,16,0,0,0-2.79-2S680.7,248.57,685.74,249.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.38,270.39s-1.74-2.13-3.88-2.32a16.22,16.22,0,0,0-3.45,0S702.85,272.73,707.38,270.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.58,275.49s-1.74-2.13-3.88-2.32a16.22,16.22,0,0,0-3.45,0S712.05,277.83,716.58,275.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.39,269.74s1.74-2.13,3.88-2.32a16.22,16.22,0,0,1,3.45,0S677.92,272.08,673.39,269.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.55,273.62s1.74-2.13,3.88-2.32a16.22,16.22,0,0,1,3.45,0S665.08,276,660.55,273.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.09,247a6.75,6.75,0,0,0-1.77-4.16,16.68,16.68,0,0,0-2.79-2S673,246.24,678.09,247Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.58,237.86s-.15-2.75-1.76-4.17a16,16,0,0,0-2.8-2S665.54,237.07,670.58,237.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.53,248.58s.15-2.75,1.77-4.16a15.54,15.54,0,0,1,2.79-2S708.57,247.79,703.53,248.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.78,243.5a6.75,6.75,0,0,1,1.77-4.16,16.18,16.18,0,0,1,2.79-2S717.83,242.72,712.78,243.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.86,245.05s1.59-2.25,1.2-4.36a15.41,15.41,0,0,0-.94-3.32S687.39,241.3,690.86,245.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.63,255.39s.26-2.74-1.13-4.38a15.8,15.8,0,0,0-2.47-2.42S687.76,253.86,692.63,255.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.1,242.88s.82-2.63-.2-4.52a16.11,16.11,0,0,0-1.91-2.88S681.65,240.37,686.1,242.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.1,232.43s.82-2.63-.2-4.52A15.74,15.74,0,0,0,684,225S681.65,229.93,686.1,232.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.17,263.26s.82-2.63-.2-4.52a16.09,16.09,0,0,0-1.9-2.87S683.72,260.75,688.17,263.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.33,260.17s2.32-1.47,2.76-3.57a15.85,15.85,0,0,0,.41-3.43S692.55,255.39,694.33,260.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.6,242.88s-.82-2.63.2-4.52a16.11,16.11,0,0,1,1.91-2.88S699.05,240.37,694.6,242.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.25,234a6.76,6.76,0,0,1,.2-4.52,16.09,16.09,0,0,1,1.9-2.87S707.7,231.53,703.25,234Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.84,249.48s2.32-1.49,2.76-3.59a16.46,16.46,0,0,0,.39-3.43S696.05,244.7,697.84,249.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.09,256.67s2.66-.69,3.73-2.56a15.88,15.88,0,0,0,1.44-3.14S703.86,251.57,704.09,256.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.69,263.09s2.5,1.15,4.5.38a16.14,16.14,0,0,0,3.1-1.52S707.74,259,704.69,263.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.19,257.25s2.5,1.15,4.51.38a16.14,16.14,0,0,0,3.1-1.52S711.25,253.16,708.19,257.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.24,257.79s2.5,1.15,4.51.38a15.14,15.14,0,0,0,3.09-1.52S722.3,253.7,719.24,257.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.23,261s1.67,2.18,3.81,2.43a16.08,16.08,0,0,0,3.45.09S677.83,258.77,673.23,261Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.77,253.45s1.68,2.18,3.82,2.43A16,16,0,0,0,675,256S672.38,251.24,667.77,253.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.94,252s1.67,2.18,3.81,2.43a16.08,16.08,0,0,0,3.45.09S659.54,249.75,654.94,252Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "707.25 271.57 697.08 273.77 709.21 258.65 692.65 274.1 692.54 275.17 691.8 258.93 690.63 284.57 674.3 269.35 686.43 284.46 676.27 282.26 689.12 287.8 690.41 289.42 688.15 374.25 695.45 374.25 692.73 279.19 694.4 277.11 707.25 271.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86,217.87c-25.39,0-46,19.59-46,43.69v.37A23.59,23.59,0,0,0,56,285.25a34.89,34.89,0,0,1,6.38.4,15.89,15.89,0,0,1,10,6.2,6.67,6.67,0,0,0,5.21,2.66h.49a6.65,6.65,0,0,0,5.21-2.66,15.89,15.89,0,0,1,10-6.2,34.89,34.89,0,0,1,6.38-.4,23.59,23.59,0,0,0,24.13-23.32v-.37C123.81,237.46,103.24,217.91,77.86,217.87Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86,217.87c-25.39,0-46,19.59-46,43.69v.37A23.59,23.59,0,0,0,56,285.25a34.89,34.89,0,0,1,6.38.4,15.89,15.89,0,0,1,10,6.2,6.67,6.67,0,0,0,5.21,2.66h.49a6.65,6.65,0,0,0,5.21-2.66,15.89,15.89,0,0,1,10-6.2,34.89,34.89,0,0,1,6.38-.4,23.59,23.59,0,0,0,24.13-23.32v-.37C123.81,237.46,103.24,217.91,77.86,217.87Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,256.26s-.91-2.6-2.86-3.51a16.31,16.31,0,0,0-3.24-1.16S64.84,256.91,69.9,256.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.25,249.36s-.15-2.75-1.77-4.16a15.54,15.54,0,0,0-2.79-2S67.21,248.57,72.25,249.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.89,270.39s-1.75-2.13-3.89-2.32a16.22,16.22,0,0,0-3.45,0S89.35,272.73,93.89,270.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.09,275.49s-1.74-2.13-3.88-2.32a16.17,16.17,0,0,0-3.45,0S98.55,277.83,103.09,275.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.89,269.74s1.74-2.13,3.88-2.32a16.22,16.22,0,0,1,3.45,0S64.43,272.08,59.89,269.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.05,273.62s1.74-2.13,3.89-2.32a16.1,16.1,0,0,1,3.44,0S51.59,276,47.05,273.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.59,247a6.75,6.75,0,0,0-1.77-4.16,16.21,16.21,0,0,0-2.79-2S59.55,246.24,64.59,247Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.09,237.86s-.15-2.75-1.77-4.17a16.18,16.18,0,0,0-2.79-2S52,237.07,57.09,237.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,248.58s.15-2.75,1.77-4.16a16,16,0,0,1,2.79-2S95.08,247.79,90,248.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.29,243.5a6.75,6.75,0,0,1,1.77-4.16,15.74,15.74,0,0,1,2.79-2S104.33,242.72,99.29,243.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37,245.05s1.58-2.25,1.19-4.36a15.84,15.84,0,0,0-.93-3.32S73.9,241.3,77.37,245.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.13,255.39s.26-2.74-1.13-4.38a16.06,16.06,0,0,0-2.46-2.42S74.26,253.86,79.13,255.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,242.88s.82-2.63-.2-4.52a16.48,16.48,0,0,0-1.9-2.88S68.15,240.37,72.6,242.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,232.43s.82-2.63-.2-4.52A16.09,16.09,0,0,0,70.5,225S68.15,229.93,72.6,232.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.68,263.26s.82-2.63-.2-4.52a15.74,15.74,0,0,0-1.91-2.87S70.23,260.75,74.68,263.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.83,260.17s2.32-1.47,2.77-3.57a16.15,16.15,0,0,0,.4-3.43S79.05,255.39,80.83,260.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.11,242.88s-.82-2.63.19-4.52a16.11,16.11,0,0,1,1.91-2.88S85.56,240.37,81.11,242.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75,234a6.76,6.76,0,0,1,.2-4.52,15.74,15.74,0,0,1,1.91-2.87S94.2,231.53,89.75,234Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.35,249.48s2.31-1.49,2.75-3.59a15.65,15.65,0,0,0,.39-3.43S82.55,244.7,84.35,249.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6,256.67s2.66-.69,3.73-2.56A16.14,16.14,0,0,0,95.76,251S90.37,251.57,90.6,256.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.19,263.09s2.5,1.15,4.51.38A16.14,16.14,0,0,0,98.8,262S94.25,259,91.19,263.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,257.25s2.5,1.15,4.5.38a16.14,16.14,0,0,0,3.1-1.52S97.75,253.16,94.7,257.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.75,257.79s2.5,1.15,4.5.38a15.44,15.44,0,0,0,3.1-1.52S108.8,253.7,105.75,257.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.73,261s1.68,2.18,3.81,2.43a16.06,16.06,0,0,0,3.45.09S64.33,258.77,59.73,261Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28,253.45s1.68,2.18,3.81,2.43a16.06,16.06,0,0,0,3.45.09S58.88,251.24,54.28,253.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.44,252s1.68,2.18,3.81,2.43a16.06,16.06,0,0,0,3.45.09S46,249.75,41.44,252Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.75 271.57 83.59 273.77 95.72 258.65 79.15 274.1 79.05 275.17 78.31 258.93 77.14 284.57 60.81 269.35 72.94 284.46 62.77 282.26 75.62 287.8 76.92 289.42 74.66 374.25 81.96 374.25 79.23 279.19 80.9 277.11 93.75 271.57",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M627.23,376a.21.21,0,0,1-.12-.25,26.63,26.63,0,0,1,19.13-17.58.23.23,0,0,1,.26.16.22.22,0,0,1-.16.25,26.22,26.22,0,0,0-18.83,17.3.21.21,0,0,1-.27.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.26,370.4c-2-1.64-5.11,1.07-5.06,1.17-.23.38-.44.77-.64,1.16.43-.4,1.87-.63,3.75-.21S636.2,371.88,634.26,370.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.33,365.94c-2-1.53-3,1.8-1.66,3.35s1.88,2.84,1.86,3.43c.17-.41.36-.81.55-1.21C629,371.5,630.17,367.46,628.33,365.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.79,367.56c-1.67-1.94-5.19.17-5.16.27q-.42.5-.81,1c.49-.31,1.94-.28,3.72.46S638.45,369.35,636.79,367.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.7,362.17c-1.71-1.84-3.21,1.25-2.18,3s1.39,3.1,1.27,3.67c.24-.37.49-.73.74-1.08C631.44,367.73,633.26,364,631.7,362.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.76,365.2c-1.34-2.19-5.14-.71-5.12-.61-.33.28-.65.57-1,.87.53-.23,2,.05,3.58,1.08S641.09,367.25,639.76,365.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.64,359c-1.38-2.11-3.37.69-2.64,2.57s.86,3.28.64,3.82c.3-.32.6-.63.91-.93C634.46,364.46,636.87,361.09,635.64,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.08,363.36c-1-2.38-5-1.55-5-1.45-.37.22-.74.45-1.1.69.56-.13,1.91.38,3.35,1.67S644.05,365.61,643.08,363.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.05,356.6c-1-2.31-3.45.12-3,2.1s.3,3.38,0,3.87c.34-.26.69-.52,1-.76C638,361.75,640.91,358.83,640.05,356.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.69,362.1c-.54-2.51-4.66-2.35-4.67-2.25-.4.15-.8.32-1.2.5.58,0,1.83.69,3,2.2S647.27,364.48,646.69,362.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.85,354.92c-.61-2.44-3.45-.45-3.39,1.57s-.28,3.39-.65,3.82l1.16-.58C641.89,359.67,645.32,357.26,644.85,354.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.36,358.9a15.43,15.43,0,0,1,5.08-2.46c2-.38,2.74,1,2.41,1.83s-1.7,1-2.88,1S644.38,358.84,644.36,358.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.31,359h0a.13.13,0,0,1-.06-.15h0a.11.11,0,0,1,.07-.09,15,15,0,0,1,5.12-2.47,2.32,2.32,0,0,1,2.29.61,1.43,1.43,0,0,1,.27,1.41c-.42,1.12-2.42,1.1-3,1.06-1.13-.16-4.25-.37-4.55-.35A.17.17,0,0,1,644.31,359Zm6.58-2.37a2.44,2.44,0,0,0-1.42-.08,15,15,0,0,0-4.68,2.17l1.46.1c.91.06,2.12.17,2.74.25,1.13.07,2.45-.13,2.73-.88a1.15,1.15,0,0,0-.23-1.13A1.43,1.43,0,0,0,650.89,356.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.38,375.83a.21.21,0,0,1-.27-.08,26.61,26.61,0,0,1,.15-26,.2.2,0,0,1,.28-.08.2.2,0,0,1,.08.28,26.21,26.21,0,0,0-.14,25.57.22.22,0,0,1-.09.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.05,366.87c-2.54.33-2.68,4.47-2.58,4.5.13.43.27.84.42,1.26,0-.59.81-1.79,2.4-2.89S630.46,366.46,628.05,366.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.76,368.18c-2.48.41-.71,3.4,1.32,3.5s3.36.55,3.77,1c-.18-.41-.34-.82-.5-1.24C625.27,371.48,623.12,367.87,620.76,368.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.7,363.08c-2.56-.09-3.4,3.92-3.31,4,.05.43.12.87.19,1.3.11-.58,1.11-1.62,2.87-2.42S630.15,363.08,627.7,363.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.29,363.14c-2.52,0-1.27,3.21.71,3.64s3.21,1.09,3.55,1.56c-.11-.42-.2-.85-.29-1.28C624.18,367.12,622.68,363.24,620.29,363.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628,359.3c-2.51-.51-4,3.29-3.93,3.34,0,.43,0,.86,0,1.3.2-.55,1.37-1.39,3.24-1.89S630.4,359.71,628,359.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.67,358.12c-2.48-.42-1.79,2.94.09,3.69s3,1.61,3.24,2.13c0-.44-.06-.87-.07-1.3C623.84,362.68,623,358.62,620.67,358.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.9,355.62c-2.39-.93-4.5,2.58-4.43,2.64-.09.42-.17.84-.24,1.27.29-.5,1.58-1.14,3.5-1.31S631.21,356.43,628.9,355.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.89,353.23c-2.38-.83-2.26,2.61-.54,3.66s2.68,2.08,2.84,2.64c0-.43.09-.86.16-1.29C624.25,358.27,624.11,354.12,621.89,353.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.44,352.11c-2.21-1.31-4.9,1.82-4.83,1.89-.16.4-.31.81-.45,1.22.37-.45,1.75-.87,3.67-.72S632.57,353.3,630.44,352.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.93,348.58c-2.21-1.22-2.68,2.22-1.16,3.55s2.29,2.51,2.35,3.08c.11-.42.24-.84.37-1.25C625.39,354,626,349.83,623.93,348.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.51,351.64a15.29,15.29,0,0,1,1.65-5.4c1.07-1.71,2.61-1.31,3-.51s-.4,1.95-1.25,2.77S626.47,351.58,626.51,351.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.57,351.76h0a.14.14,0,0,1-.16,0h0a.1.1,0,0,1,0-.11,14.91,14.91,0,0,1,1.68-5.43,2.26,2.26,0,0,1,2-1.26,1.42,1.42,0,0,1,1.22.76c.53,1.07-.85,2.51-1.28,2.93-.89.72-3.17,2.86-3.36,3.09A.09.09,0,0,1,626.57,351.76Zm2.74-6.43a2.47,2.47,0,0,0-1,1,14.75,14.75,0,0,0-1.59,4.91l1.06-1c.67-.62,1.57-1.43,2-1.83.82-.78,1.57-1.88,1.22-2.6a1.14,1.14,0,0,0-1-.6A1.55,1.55,0,0,0,629.31,345.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.12,364a.13.13,0,0,1-.08-.17,17.39,17.39,0,0,1,12.5-11.48.14.14,0,0,1,.16.11.13.13,0,0,1-.1.16,17.13,17.13,0,0,0-12.3,11.3.15.15,0,0,1-.18.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.71,360.29c-1.3-1.07-3.34.7-3.31.76l-.42.76a3.3,3.3,0,0,1,2.46-.13C58.67,361.91,60,361.26,58.71,360.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.84,357.38c-1.31-1-1.94,1.17-1.09,2.19A4.84,4.84,0,0,1,55,361.8c.12-.26.24-.53.37-.79C55.26,361,56,358.37,54.84,357.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.36,358.43c-1.09-1.26-3.39.12-3.37.18-.18.22-.36.44-.53.67a3.24,3.24,0,0,1,2.43.3C60.06,360,61.45,359.61,60.36,358.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,354.92c-1.12-1.21-2.1.81-1.43,1.95a4.92,4.92,0,0,1,.83,2.4c.16-.24.32-.48.49-.71C56.86,358.54,58.05,356.1,57,354.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,356.89c-.87-1.43-3.36-.46-3.35-.39l-.63.56a3.35,3.35,0,0,1,2.34.71C61.74,358.4,63.17,358.23,62.3,356.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.61,352.87c-.9-1.38-2.2.45-1.73,1.68a4.94,4.94,0,0,1,.43,2.49c.19-.2.39-.41.59-.6C58.84,356.41,60.41,354.21,59.61,352.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.47,355.69c-.62-1.55-3.24-1-3.24-.94-.24.14-.48.29-.71.45a3.21,3.21,0,0,1,2.18,1.09C63.66,357.09,65.1,357.16,64.47,355.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.49,351.27c-.66-1.5-2.25.09-2,1.38a4.87,4.87,0,0,1,0,2.53c.23-.18.46-.34.69-.5C61.13,354.64,63.05,352.73,62.49,351.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,354.87c-.35-1.64-3-1.54-3-1.47l-.78.32a3.35,3.35,0,0,1,2,1.44C65.78,356.11,67.21,356.42,66.83,354.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,350.18c-.4-1.6-2.26-.29-2.22,1A4.88,4.88,0,0,1,63,353.7l.77-.38C63.69,353.28,65.93,351.71,65.63,350.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.31,352.78a10.17,10.17,0,0,1,3.32-1.61c1.29-.25,1.78.66,1.57,1.2s-1.11.68-1.88.63S65.32,352.74,65.31,352.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.27,352.86h0a.1.1,0,0,1,0-.1h0s0,0,0-.05a9.58,9.58,0,0,1,3.34-1.62,1.52,1.52,0,0,1,1.5.4.93.93,0,0,1,.17.92c-.27.73-1.58.72-2,.69-.74-.1-2.78-.24-3-.23Zm4.3-1.54a1.58,1.58,0,0,0-.93-.06,10,10,0,0,0-3.06,1.42l1,.06c.6.05,1.38.11,1.79.17.74,0,1.6-.08,1.78-.57a.72.72,0,0,0-.15-.74A.83.83,0,0,0,69.57,351.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.21,363.84a.12.12,0,0,1-.17-.06,17.4,17.4,0,0,1,.09-17,.14.14,0,0,1,.19-.05.13.13,0,0,1,0,.19,17.12,17.12,0,0,0-.09,16.7.15.15,0,0,1-.06.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.65,358c-1.66.22-1.75,2.93-1.68,2.95.08.27.17.55.27.82,0-.39.53-1.17,1.57-1.89S56.23,357.72,54.65,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.89,358.84c-1.62.27-.46,2.22.86,2.29a4.78,4.78,0,0,1,2.47.63q-.18-.4-.33-.81C52.84,361,51.43,358.64,49.89,358.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.42,355.51c-1.67-.06-2.22,2.56-2.16,2.59,0,.28.08.56.13.84.07-.37.72-1.05,1.87-1.58S56,355.51,54.42,355.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.58,355.55c-1.64,0-.83,2.09.46,2.38a4.85,4.85,0,0,1,2.32,1q-.11-.42-.18-.84C52.12,358.15,51.14,355.61,49.58,355.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.61,353C53,352.7,52,355.19,52,355.22c0,.28,0,.57,0,.85a3.26,3.26,0,0,1,2.11-1.23C55.34,354.48,56.19,353.31,54.61,353Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.83,352.27c-1.62-.27-1.17,1.92.06,2.41A5,5,0,0,1,52,356.07c0-.28,0-.57,0-.85C51.9,355.25,51.36,352.6,49.83,352.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.21,350.63c-1.56-.6-3,1.69-2.9,1.73-.06.28-.11.55-.15.83a3.29,3.29,0,0,1,2.28-.86C55.68,352.18,56.72,351.17,55.21,350.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.63,349.08c-1.56-.55-1.48,1.7-.35,2.39a4.85,4.85,0,0,1,1.85,1.72c0-.28.06-.56.1-.84C52.17,352.36,52.08,349.65,50.63,349.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,348.35c-1.44-.86-3.19,1.18-3.15,1.23-.11.26-.21.53-.3.79a3.35,3.35,0,0,1,2.4-.47C56.41,350,57.61,349.12,56.21,348.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,346c-1.44-.79-1.75,1.46-.76,2.32a4.87,4.87,0,0,1,1.54,2c.07-.28.15-.55.24-.82C52.91,349.56,53.29,346.85,52,346Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,348a10.28,10.28,0,0,1,1.08-3.52c.7-1.12,1.71-.86,2-.34s-.26,1.28-.82,1.81S53.62,348,53.64,348Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.68,348.12h0a.09.09,0,0,1-.1,0h0a.06.06,0,0,1,0-.07,9.65,9.65,0,0,1,1.09-3.55,1.49,1.49,0,0,1,1.31-.82,1,1,0,0,1,.8.49c.34.71-.56,1.65-.84,1.92-.58.47-2.07,1.87-2.19,2Zm1.8-4.21a1.63,1.63,0,0,0-.68.65,9.85,9.85,0,0,0-1,3.21l.7-.66c.44-.41,1-.94,1.34-1.2.53-.51,1-1.23.79-1.7a.76.76,0,0,0-.64-.39A1,1,0,0,0,55.48,343.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.38,372.47a.2.2,0,0,0,.12-.26,26.63,26.63,0,0,0-19.13-17.57.21.21,0,0,0-.26.16.22.22,0,0,0,.16.25,26.19,26.19,0,0,1,18.83,17.29.23.23,0,0,0,.27.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.36,366.86c2-1.63,5.1,1.08,5,1.17.23.39.44.77.64,1.17-.43-.4-1.87-.63-3.75-.21S586.41,368.35,588.36,366.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.28,362.41c2-1.54,3,1.79,1.67,3.35s-1.89,2.83-1.86,3.42c-.18-.41-.37-.81-.56-1.21C593.63,368,592.44,363.93,594.28,362.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.82,364c1.67-1.93,5.19.18,5.16.28q.42.49.81,1c-.49-.32-1.94-.29-3.72.46S584.16,365.82,585.82,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.91,358.64c1.71-1.85,3.21,1.25,2.18,3s-1.39,3.1-1.27,3.67c-.24-.37-.49-.73-.74-1.08C591.17,364.19,589.35,360.45,590.91,358.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.86,361.66c1.33-2.19,5.13-.7,5.11-.6.33.28.66.57,1,.86-.53-.22-2,.06-3.58,1.09S581.52,363.71,582.86,361.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587,355.5c1.38-2.1,3.37.69,2.65,2.58s-.86,3.28-.65,3.82c-.3-.32-.6-.63-.91-.94C588.15,360.93,585.74,357.55,587,355.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.53,359.83c1-2.38,5-1.55,5-1.45.37.22.73.45,1.09.69-.56-.13-1.91.38-3.34,1.67S578.56,362.07,579.53,359.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.56,353.06c1-2.3,3.45.13,3,2.11s-.29,3.38,0,3.87c-.34-.27-.69-.52-1.05-.77C584.64,358.22,581.7,355.29,582.56,353.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.92,358.57c.54-2.51,4.66-2.35,4.67-2.26l1.2.5c-.58,0-1.83.69-3,2.21S575.34,360.94,575.92,358.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.76,351.39c.61-2.44,3.45-.45,3.39,1.57s.28,3.38.65,3.82c-.38-.2-.77-.4-1.16-.58C580.72,356.13,577.29,353.73,577.76,351.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.25,355.36a15.57,15.57,0,0,0-5.08-2.45c-2-.39-2.74,1-2.41,1.83s1.71,1,2.88,1S578.23,355.3,578.25,355.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.3,355.49h0a.15.15,0,0,0,.07-.15v0a.11.11,0,0,0-.07-.08,14.85,14.85,0,0,0-5.12-2.47,2.3,2.3,0,0,0-2.29.61,1.43,1.43,0,0,0-.27,1.41c.43,1.12,2.42,1.09,3,1.06,1.13-.16,4.25-.38,4.55-.35A.12.12,0,0,0,578.3,355.49Zm-6.58-2.36a2.42,2.42,0,0,1,1.42-.09,15,15,0,0,1,4.69,2.18l-1.47.09c-.91.07-2.11.17-2.74.26-1.12.06-2.44-.13-2.73-.88a1.15,1.15,0,0,1,.23-1.13A1.43,1.43,0,0,1,571.72,353.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.23,372.3a.2.2,0,0,0,.27-.09,26.63,26.63,0,0,0-.14-26,.22.22,0,0,0-.29-.08.21.21,0,0,0-.08.29,26.21,26.21,0,0,1,.14,25.57.21.21,0,0,0,.09.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.56,363.33c2.54.34,2.69,4.48,2.58,4.51q-.2.63-.42,1.26c0-.59-.81-1.8-2.4-2.89S592.15,362.93,594.56,363.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.85,364.64c2.49.42.71,3.4-1.32,3.5s-3.36.55-3.77,1c.18-.4.34-.82.5-1.23C597.34,367.94,599.49,364.33,601.85,364.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.91,359.55c2.56-.1,3.41,3.92,3.31,4-.05.43-.12.86-.19,1.29-.11-.57-1.11-1.61-2.87-2.41S592.46,359.55,594.91,359.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.32,359.61c2.52,0,1.27,3.2-.71,3.64s-3.21,1.08-3.55,1.56c.11-.43.2-.85.29-1.28C598.43,363.58,599.93,359.7,602.32,359.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.62,355.77c2.51-.52,4,3.28,3.93,3.34q0,.64,0,1.29c-.2-.54-1.37-1.39-3.23-1.88S592.21,356.18,594.62,355.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.94,354.59c2.48-.42,1.79,2.94-.09,3.69s-3,1.6-3.24,2.12c0-.43.06-.86.07-1.3C598.77,359.15,599.6,355.09,601.94,354.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.71,352.08c2.39-.92,4.51,2.58,4.43,2.65.09.42.17.84.24,1.27-.29-.5-1.58-1.14-3.5-1.32S591.4,352.9,593.71,352.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.72,349.7c2.38-.83,2.26,2.61.54,3.66s-2.68,2.08-2.84,2.63q-.06-.64-.15-1.29C598.36,354.73,598.51,350.58,600.72,349.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.17,348.58c2.21-1.32,4.9,1.81,4.83,1.89.16.4.31.8.45,1.21-.36-.44-1.75-.86-3.67-.71S590,349.77,592.17,348.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.69,345c2.2-1.22,2.68,2.22,1.15,3.55s-2.29,2.51-2.35,3.08c-.11-.42-.24-.83-.37-1.25C597.22,350.44,596.65,346.29,598.69,345Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.1,348.1a15.26,15.26,0,0,0-1.65-5.39c-1.07-1.71-2.61-1.31-3-.52s.4,2,1.25,2.77S596.14,348.05,596.1,348.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.05,348.23h0a.16.16,0,0,0,.16-.05v0a.09.09,0,0,0,0-.1,15,15,0,0,0-1.67-5.44,2.32,2.32,0,0,0-2-1.26,1.42,1.42,0,0,0-1.22.76c-.53,1.08.85,2.52,1.28,2.93.89.73,3.17,2.86,3.36,3.1A.1.1,0,0,0,596.05,348.23Zm-2.75-6.43a2.5,2.5,0,0,1,1,1,14.79,14.79,0,0,1,1.59,4.92c-.2-.21-.54-.52-1.06-1s-1.56-1.44-2.05-1.83c-.82-.79-1.57-1.89-1.22-2.61a1.16,1.16,0,0,1,1-.6A1.44,1.44,0,0,1,593.3,341.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.05,379.1a.21.21,0,0,0,.12-.26A26.59,26.59,0,0,0,94,361.27a.21.21,0,0,0-.1.4A26.2,26.2,0,0,1,112.77,379a.21.21,0,0,0,.27.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,373.49c2-1.64,5.11,1.07,5.06,1.17.22.38.43.77.63,1.16-.43-.4-1.86-.62-3.75-.2S104.09,375,106,373.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,369c2-1.53,3,1.8,1.67,3.35s-1.89,2.84-1.86,3.43c-.18-.41-.37-.81-.56-1.21C111.3,374.59,110.11,370.56,112,369Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.49,370.65c1.68-1.94,5.19.17,5.16.27.28.33.55.68.81,1-.49-.31-1.93-.28-3.72.46S101.83,372.44,103.49,370.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.58,365.26c1.71-1.84,3.21,1.25,2.18,3s-1.39,3.1-1.27,3.66c-.24-.36-.48-.72-.74-1.08C108.84,370.82,107,367.08,108.58,365.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.53,368.29c1.33-2.19,5.13-.7,5.12-.61q.5.42,1,.87c-.53-.23-1.94.05-3.58,1.08S99.19,370.34,100.53,368.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.64,362.13c1.38-2.11,3.37.69,2.65,2.57s-.86,3.29-.65,3.82c-.3-.32-.6-.63-.91-.93C105.82,367.55,103.42,364.18,104.64,362.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.21,366.45c.94-2.38,5-1.54,5-1.45.37.22.73.45,1.09.69-.56-.13-1.91.38-3.34,1.67S96.23,368.7,97.21,366.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.23,359.69c1-2.31,3.45.12,3,2.1s-.3,3.38,0,3.87c-.34-.26-.69-.52-1-.76C102.31,364.85,99.37,361.92,100.23,359.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.59,365.19c.54-2.51,4.66-2.35,4.67-2.25.4.16.8.32,1.2.5-.58,0-1.82.69-3,2.2S93,367.57,93.59,365.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.43,358c.61-2.45,3.45-.46,3.39,1.56s.28,3.39.66,3.82l-1.17-.58C98.39,362.76,95,360.36,95.43,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.92,362a15.52,15.52,0,0,0-5.08-2.46c-2-.38-2.74,1-2.41,1.83s1.71,1,2.89,1S95.9,361.93,95.92,362Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,362.12h0a.15.15,0,0,0,.07-.15h0a.11.11,0,0,0-.07-.09,15.12,15.12,0,0,0-5.12-2.47,2.3,2.3,0,0,0-2.28.62,1.41,1.41,0,0,0-.28,1.41c.43,1.12,2.42,1.09,3,1.05,1.13-.16,4.25-.37,4.55-.35Zm-6.58-2.37a2.53,2.53,0,0,1,1.42-.08,15,15,0,0,1,4.69,2.18l-1.46.09c-.92.06-2.12.17-2.74.25-1.13.07-2.45-.13-2.74-.88a1.15,1.15,0,0,1,.23-1.13A1.6,1.6,0,0,1,89.39,359.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9,378.93a.22.22,0,0,0,.27-.09,26.63,26.63,0,0,0-.14-26,.21.21,0,0,0-.29-.08.22.22,0,0,0-.08.29,26.19,26.19,0,0,1,.15,25.56.21.21,0,0,0,.08.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,370c2.54.34,2.69,4.48,2.58,4.51-.12.42-.26.84-.41,1.25,0-.59-.82-1.79-2.41-2.89S109.82,369.55,112.23,370Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,371.27c2.49.42.71,3.4-1.31,3.5s-3.37.55-3.78,1c.18-.41.35-.82.5-1.23C115,374.57,117.16,371,119.52,371.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,366.17c2.56-.09,3.41,3.92,3.31,4,0,.43-.11.86-.19,1.29-.1-.58-1.11-1.61-2.87-2.42S110.14,366.17,112.58,366.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,366.23c2.52,0,1.27,3.21-.7,3.64s-3.22,1.09-3.55,1.56c.1-.42.2-.85.28-1.27C116.1,370.21,117.61,366.33,120,366.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3,362.39c2.51-.51,4,3.29,3.92,3.34,0,.43,0,.86,0,1.3-.2-.55-1.37-1.39-3.23-1.89S109.89,362.81,112.3,362.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.61,361.22c2.48-.43,1.79,2.94-.09,3.69s-3,1.6-3.23,2.12c0-.43,0-.87.06-1.3C116.44,365.77,117.28,361.71,119.61,361.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.38,358.71c2.39-.93,4.51,2.58,4.43,2.64.09.42.17.85.24,1.27-.28-.5-1.57-1.14-3.5-1.31S109.07,359.52,111.38,358.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.4,356.32c2.37-.83,2.25,2.61.53,3.67s-2.68,2.08-2.84,2.63q-.06-.64-.15-1.29C116,361.36,116.18,357.21,118.4,356.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,355.21c2.2-1.32,4.89,1.81,4.82,1.88.16.4.31.81.46,1.22-.37-.45-1.75-.87-3.68-.72S107.71,356.4,109.85,355.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.36,351.67c2.2-1.22,2.68,2.22,1.15,3.55s-2.29,2.51-2.35,3.08c-.11-.42-.23-.84-.37-1.25C114.9,357.06,114.32,352.92,116.36,351.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.78,354.73a15.58,15.58,0,0,0-1.66-5.39c-1.07-1.72-2.6-1.32-3-.52s.4,1.95,1.25,2.77S113.81,354.68,113.78,354.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.72,354.86h0a.13.13,0,0,0,.15-.05h0a.1.1,0,0,0,0-.11,15.06,15.06,0,0,0-1.67-5.43,2.32,2.32,0,0,0-2-1.26,1.45,1.45,0,0,0-1.22.76c-.53,1.07.85,2.51,1.29,2.93.88.72,3.16,2.86,3.35,3.09A.14.14,0,0,0,113.72,354.86ZM111,348.42a2.42,2.42,0,0,1,1,1,15,15,0,0,1,1.6,4.91c-.21-.21-.55-.52-1.07-1-.67-.62-1.56-1.43-2-1.83-.82-.78-1.57-1.88-1.22-2.6a1.16,1.16,0,0,1,1-.6A1.53,1.53,0,0,1,111,348.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718,371.49a.13.13,0,0,0,.08-.17,17.69,17.69,0,0,0-12.72-11.68.13.13,0,0,0-.16.1.14.14,0,0,0,.1.17,17.43,17.43,0,0,1,12.52,11.5.15.15,0,0,0,.18.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.31,367.76c1.32-1.08,3.4.72,3.37.78.14.26.29.51.42.78a3.32,3.32,0,0,0-2.5-.14C713.35,369.41,712,368.75,713.31,367.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.25,364.8c1.33-1,2,1.2,1.11,2.23a5,5,0,0,0-1.24,2.28c-.11-.28-.24-.54-.37-.81C716.82,368.49,716,365.81,717.25,364.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.63,365.88c1.11-1.29,3.45.11,3.43.18l.54.68a3.34,3.34,0,0,0-2.47.3C711.93,367.49,710.52,367.07,711.63,365.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715,362.3c1.14-1.23,2.14.83,1.45,2a5,5,0,0,0-.84,2.43c-.16-.24-.33-.48-.5-.71C715.19,366,714,363.5,715,362.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.66,364.31c.88-1.46,3.41-.47,3.4-.4.22.18.43.37.64.57a3.39,3.39,0,0,0-2.38.72C710.23,365.84,708.77,365.67,709.66,364.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.39,360.21c.92-1.4,2.24.46,1.76,1.71a5,5,0,0,0-.43,2.54l-.6-.62C713.18,363.82,711.58,361.58,712.39,360.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.45,363.09c.63-1.59,3.29-1,3.29-1l.73.46a3.38,3.38,0,0,0-2.22,1.11C708.27,364.51,706.8,364.58,707.45,363.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.46,358.59c.67-1.53,2.29.08,2,1.4a5.07,5.07,0,0,0,0,2.57l-.69-.51C710.84,362,708.89,360.07,709.46,358.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.05,362.25c.35-1.67,3.09-1.56,3.1-1.5l.8.33a3.36,3.36,0,0,0-2,1.47C706.11,363.52,704.66,363.83,705.05,362.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.27,357.48c.4-1.63,2.3-.3,2.25,1a5,5,0,0,0,.44,2.54l-.78-.39C708.24,360.63,706,359,706.27,357.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.59,360.12a10.29,10.29,0,0,0-3.37-1.63c-1.32-.26-1.82.67-1.6,1.21s1.13.69,1.91.65S706.58,360.08,706.59,360.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.63,360.21h0a.1.1,0,0,0,.05-.1h0a.05.05,0,0,0,0,0,9.82,9.82,0,0,0-3.41-1.64,1.53,1.53,0,0,0-1.52.4,1,1,0,0,0-.18.94c.28.74,1.61.72,2,.7.75-.1,2.83-.25,3-.23A.16.16,0,0,0,706.63,360.21Zm-4.38-1.58a1.67,1.67,0,0,1,1-.05,9.9,9.9,0,0,1,3.11,1.44l-1,.07c-.61,0-1.41.11-1.82.17-.75,0-1.63-.09-1.82-.59a.76.76,0,0,1,.16-.75A1,1,0,0,1,702.25,358.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.88,371.38a.14.14,0,0,0,.18-.06,17.72,17.72,0,0,0-.09-17.27.14.14,0,0,0-.19-.05.15.15,0,0,0-.06.19,17.41,17.41,0,0,1,.1,17,.14.14,0,0,0,0,.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.44,365.42c1.69.22,1.78,3,1.71,3q-.12.42-.27.84c0-.39-.54-1.19-1.6-1.92S715.83,365.15,717.44,365.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.29,366.29c1.65.28.47,2.26-.88,2.33a5,5,0,0,0-2.51.64c.12-.27.23-.54.33-.82C719.29,368.48,720.71,366.08,722.29,366.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.67,362.9c1.7-.06,2.27,2.61,2.2,2.64,0,.28-.08.57-.13.85-.07-.38-.73-1.07-1.9-1.6S716.05,362.9,717.67,362.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.6,362.94c1.67,0,.84,2.13-.47,2.42a4.87,4.87,0,0,0-2.36,1c.07-.28.13-.57.19-.85C720,365.58,721,363,722.6,362.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.48,360.39c1.67-.34,2.67,2.18,2.61,2.22,0,.28,0,.57,0,.86a3.33,3.33,0,0,0-2.15-1.25C716.74,361.85,715.88,360.66,717.48,360.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.34,359.61c1.65-.28,1.19,1.95-.05,2.45a5.07,5.07,0,0,0-2.16,1.41c0-.29,0-.57,0-.86C720.24,362.63,720.79,359.94,722.34,359.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.87,357.94c1.59-.62,3,1.71,3,1.76.06.28.11.56.16.84a3.35,3.35,0,0,0-2.33-.87C716.39,359.51,715.34,358.48,716.87,357.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.54,356.35c1.58-.55,1.5,1.74.35,2.44a5,5,0,0,0-1.89,1.75c0-.29-.06-.57-.1-.86C720,359.7,720.06,356.94,721.54,356.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.85,355.61c1.47-.87,3.25,1.21,3.21,1.25q.16.4.3.81a3.39,3.39,0,0,0-2.44-.47C715.65,357.25,714.43,356.4,715.85,355.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.18,353.26c1.47-.81,1.78,1.48.77,2.36a5,5,0,0,0-1.56,2.05c-.08-.28-.16-.56-.25-.83C719.21,356.85,718.83,354.09,720.18,353.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.47,355.29a10.42,10.42,0,0,0-1.11-3.58c-.71-1.14-1.73-.88-2-.35s.27,1.3.84,1.85S718.49,355.26,718.47,355.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.43,355.38h0a.09.09,0,0,0,.1,0h0a.06.06,0,0,0,0-.07,9.8,9.8,0,0,0-1.11-3.61,1.52,1.52,0,0,0-1.33-.84,1,1,0,0,0-.81.5c-.35.72.56,1.68.85,1.95.59.48,2.11,1.9,2.23,2.06A.12.12,0,0,0,718.43,355.38Zm-1.83-4.28a1.61,1.61,0,0,1,.69.66,10,10,0,0,1,1.05,3.26c-.13-.14-.35-.34-.7-.67s-1-1-1.37-1.22c-.54-.52-1-1.25-.8-1.73a.74.74,0,0,1,.65-.39A.93.93,0,0,1,716.6,351.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,371.49a.14.14,0,0,1-.08-.17,17.71,17.71,0,0,1,12.72-11.68.14.14,0,0,1,.07.27,17.41,17.41,0,0,0-12.52,11.5.16.16,0,0,1-.18.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.67,367.76c-1.31-1.08-3.39.72-3.36.78-.15.26-.29.51-.42.78a3.3,3.3,0,0,1,2.49-.14C164.64,369.41,166,368.75,164.67,367.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.74,364.8c-1.33-1-2,1.2-1.11,2.23a5,5,0,0,1,1.23,2.28c.12-.28.24-.54.38-.81C161.17,368.49,162,365.81,160.74,364.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.36,365.88c-1.12-1.29-3.45.11-3.43.18-.19.22-.37.45-.54.68a3.34,3.34,0,0,1,2.47.3C166.05,367.49,167.46,367.07,166.36,365.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,362.3c-1.14-1.23-2.14.83-1.46,2a4.91,4.91,0,0,1,.85,2.43c.16-.24.32-.48.49-.71C162.8,366,164,363.5,163,362.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.33,364.31c-.89-1.46-3.42-.47-3.4-.4-.22.18-.44.37-.65.57a3.37,3.37,0,0,1,2.38.72C167.76,365.84,169.22,365.67,168.33,364.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59,360.21c-.91-1.4-2.24.46-1.75,1.71a5,5,0,0,1,.43,2.54c.19-.21.39-.42.6-.62C164.81,363.82,166.41,361.58,165.59,360.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.54,363.09c-.63-1.59-3.3-1-3.29-1l-.73.46a3.38,3.38,0,0,1,2.22,1.11C169.72,364.51,171.19,364.58,170.54,363.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.53,358.59c-.67-1.53-2.3.08-2,1.4a4.91,4.91,0,0,1,0,2.57l.7-.51C167.14,362,169.1,360.07,168.53,358.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.94,362.25c-.36-1.67-3.1-1.56-3.1-1.5l-.8.33a3.38,3.38,0,0,1,2,1.47C171.88,363.52,173.32,363.83,172.94,362.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.72,357.48c-.41-1.63-2.3-.3-2.26,1a5.07,5.07,0,0,1-.43,2.54l.77-.39C169.75,360.63,172,359,171.72,357.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.39,360.12a10.38,10.38,0,0,1,3.38-1.63c1.31-.26,1.82.67,1.6,1.21s-1.13.69-1.92.65S171.4,360.08,171.39,360.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36,360.21h0a.09.09,0,0,1,0-.1h0a.08.08,0,0,1,0,0,9.76,9.76,0,0,1,3.4-1.64,1.52,1.52,0,0,1,1.52.4,1,1,0,0,1,.19.94c-.29.74-1.61.72-2,.7-.75-.1-2.83-.25-3-.23C171.4,360.22,171.38,360.21,171.36,360.21Zm4.37-1.58a1.64,1.64,0,0,0-.94-.05,9.86,9.86,0,0,0-3.12,1.44l1,.07c.61,0,1.41.11,1.83.17.75,0,1.62-.09,1.81-.59a.73.73,0,0,0-.15-.75A1,1,0,0,0,175.73,358.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.1,371.38a.15.15,0,0,1-.18-.06,17.69,17.69,0,0,1,.1-17.27.14.14,0,1,1,.24.14,17.41,17.41,0,0,0-.09,17,.14.14,0,0,1-.06.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.55,365.42c-1.69.22-1.79,3-1.72,3,.09.28.18.56.28.84,0-.39.54-1.19,1.6-1.92S162.15,365.15,160.55,365.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.7,366.29c-1.65.28-.47,2.26.88,2.33a5,5,0,0,1,2.51.64c-.12-.27-.23-.54-.34-.82C158.7,368.48,157.27,366.08,155.7,366.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31,362.9c-1.7-.06-2.26,2.61-2.2,2.64,0,.28.08.57.13.85.07-.38.74-1.07,1.91-1.6S161.94,362.9,160.31,362.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.39,362.94c-1.67,0-.84,2.13.47,2.42a4.87,4.87,0,0,1,2.36,1c-.07-.28-.13-.57-.19-.85C158,365.58,157,363,155.39,362.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51,360.39c-1.67-.34-2.67,2.18-2.62,2.22,0,.28,0,.57,0,.86a3.33,3.33,0,0,1,2.15-1.25C161.24,361.85,162.11,360.66,160.51,360.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.64,359.61c-1.65-.28-1.19,1.95.06,2.45a4.94,4.94,0,0,1,2.15,1.41c0-.29,0-.57,0-.86C157.75,362.63,157.2,359.94,155.64,359.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.11,357.94c-1.58-.62-3,1.71-2.94,1.76-.06.28-.12.56-.16.84a3.35,3.35,0,0,1,2.32-.87C161.6,359.51,162.65,358.48,161.11,357.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.45,356.35c-1.58-.55-1.5,1.74-.35,2.44a4.85,4.85,0,0,1,1.88,1.75c0-.29.06-.57.1-.86C158,359.7,157.93,356.94,156.45,356.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.13,355.61c-1.46-.87-3.25,1.21-3.2,1.25q-.17.4-.3.81a3.39,3.39,0,0,1,2.44-.47C162.34,357.25,163.55,356.4,162.13,355.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.81,353.26c-1.47-.81-1.79,1.48-.77,2.36a5,5,0,0,1,1.56,2.05c.08-.28.16-.56.25-.83C158.78,356.85,159.16,354.09,157.81,353.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,355.29a10.56,10.56,0,0,1,1.1-3.58c.71-1.14,1.73-.88,2-.35s-.26,1.3-.83,1.85S159.5,355.26,159.52,355.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.56,355.38h0a.09.09,0,0,1-.1,0h0a.08.08,0,0,1,0-.07,9.8,9.8,0,0,1,1.11-3.61,1.54,1.54,0,0,1,1.34-.84,1,1,0,0,1,.81.5c.35.72-.57,1.68-.85,1.95-.59.48-2.11,1.9-2.23,2.06Zm1.83-4.28a1.61,1.61,0,0,0-.69.66,9.77,9.77,0,0,0-1.06,3.26l.71-.67c.45-.41,1-1,1.36-1.22.55-.52,1-1.25.81-1.73a.75.75,0,0,0-.65-.39A.93.93,0,0,0,161.39,351.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.45,327.44s-2.67,4.08-3.69,5.89-2.43,12.47-2.11,15.14,2.51,4.55,6.43,6.19,5.25-.94,5.25-.94,1.73-14,1.73-16.47-2.28-12.47-3.69-13.89S487.45,327.44,487.45,327.44Z",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.47,355.71a6.62,6.62,0,0,1-2.59-.59c-4.33-1.81-6.41-3.85-6.73-6.59s1.08-13.5,2.18-15.45c1-1.73,3.41-5.47,3.68-5.88.36-.79,2.05-4.26,3.62-4.55a1.21,1.21,0,0,1,1.1.36c1.55,1.55,3.83,11.75,3.83,14.24s-1.66,16-1.73,16.53a.48.48,0,0,1-.05.17A3.74,3.74,0,0,1,490.47,355.71Zm.38-32.08h-.05c-.79.14-2.17,2.43-2.89,4a.25.25,0,0,0,0,.07s-2.67,4.08-3.67,5.85c-.91,1.61-2.37,12.15-2.06,14.84.28,2.34,2.17,4.13,6.13,5.79,3.11,1.31,4.35-.28,4.58-.64.16-1.28,1.71-14.05,1.71-16.31,0-2.43-2.3-12.29-3.54-13.53A.24.24,0,0,0,490.85,323.63Zm-3.4,3.81h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503,294.6s-7.08.89-6.48,3.49a6.26,6.26,0,0,0,1.4,3c0,.3-3.29.79-3.19,2.89a3.58,3.58,0,0,0,2.49,3c.3.1.8,1.69,1.3,2.59a10.53,10.53,0,0,1,.79,2.09s-1.59,1.2-.89,2.4,2.89,2.49,5.28,2.89,5.68-.3,7.87-.8a5.83,5.83,0,0,0,3.69-2.09c.5-.7.3-1.3.2-2.2s.2-1.09,1-2.49,3.39-4.19,1.79-7.18a15.77,15.77,0,0,0-5-5.08s.4-1.8-3.69-2.79A10,10,0,0,0,503,294.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.27,317.55a10,10,0,0,1-1.68-.13c-2.45-.41-4.82-1.72-5.64-3.13a2.3,2.3,0,0,1,.76-2.82,8.7,8.7,0,0,0-.66-1.68,13.82,13.82,0,0,1-.62-1.33,8.63,8.63,0,0,0-.49-1.06A4,4,0,0,1,494.2,304c-.09-1.88,1.93-2.68,2.9-3.06l0,0A6.53,6.53,0,0,1,496,298.2a1.85,1.85,0,0,1,.31-1.5c1.26-1.81,5.7-2.48,6.52-2.59a10.63,10.63,0,0,1,6.84-.3c3.49.85,4,2.31,4.08,3a16,16,0,0,1,4.92,5.12c1.47,2.76-.27,5.34-1.31,6.89-.19.29-.37.55-.5.77l-.45.77c-.45.73-.54.88-.48,1.42,0,.14,0,.28.05.41a2.63,2.63,0,0,1-.34,2.13,6.43,6.43,0,0,1-4,2.29A30.72,30.72,0,0,1,505.27,317.55Zm1.28-23.13a8,8,0,0,0-3.35.62.48.48,0,0,1-.17,0c-1.33.17-5,.9-5.9,2.18a.83.83,0,0,0-.15.7,4.81,4.81,0,0,0,1.11,2.5.91.91,0,0,1,.3.61c0,.42-.37.56-.92.78-1.13.44-2.33,1-2.27,2.08a3.06,3.06,0,0,0,2.15,2.54c.37.13.57.55,1,1.59.19.44.38.9.57,1.24a10.14,10.14,0,0,1,.85,2.21.5.5,0,0,1-.19.52s-1.23.95-.76,1.74c.58,1,2.58,2.26,4.93,2.65s6-.4,7.68-.79a5.48,5.48,0,0,0,3.4-1.89c.29-.41.26-.73.16-1.42,0-.14,0-.28,0-.43a2.77,2.77,0,0,1,.61-2c.13-.21.28-.45.45-.75s.32-.52.53-.83c1-1.45,2.44-3.63,1.25-5.86a15.55,15.55,0,0,0-4.8-4.9.51.51,0,0,1-.23-.53h0s.15-1.35-3.32-2.2A12.35,12.35,0,0,0,506.55,294.42Zm-3.58.18h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.81,365.64l.41,2.73s-12.71-3.5-14.17-3.94-4.39-27.19-4.39-27.19l6.58-8.17s5.85,14.47,6.87,17.24S527.25,359.25,527.81,365.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.22,368.87a.32.32,0,0,1-.13,0c-.52-.14-12.73-3.51-14.18-3.94s-3.39-15.26-4.75-27.61a.46.46,0,0,1,.11-.37l6.59-8.17a.48.48,0,0,1,.46-.18.5.5,0,0,1,.39.3c.06.15,5.86,14.51,6.87,17.26,1.17,3.16,4.18,13.25,4.73,19.44l.41,2.72a.55.55,0,0,1-.16.45A.52.52,0,0,1,528.22,368.87ZM514.28,364c1.54.45,10.65,3,13.34,3.72l-.3-2v0c-.53-6.09-3.51-16.06-4.67-19.2-.87-2.36-5.31-13.37-6.54-16.43l-5.92,7.35C511.51,349.46,513.38,362.71,514.28,364Zm0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504,409.39l2.23,2s5.34,1.56,5.53,2.33a4.64,4.64,0,0,1,.1,1.55s-8.54.2-9.41.1-4.85-.68-6.6-.68-1.74-1.65-.58-3.59S504,409.39,504,409.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.85,415.93c-.7,0-1.22,0-1.41,0l-1-.12c-1.48-.2-4.25-.56-5.59-.56a1.75,1.75,0,0,1-1.66-.82c-.46-.81-.22-2.06.65-3.52,1.25-2.09,7.87-2,9.18-2a.48.48,0,0,1,.32.13l2.15,2c3.65,1.06,5.59,2,5.76,2.65a5.64,5.64,0,0,1,.11,1.74.5.5,0,0,1-.49.43C511.23,415.82,506.37,415.93,503.85,415.93Zm-.55-6.05c-2.84,0-6.88.38-7.56,1.51-.78,1.31-.83,2.17-.64,2.51s.39.32.79.32c1.41,0,4.11.36,5.72.57l.94.11c.59.07,5.46,0,8.88-.08a5,5,0,0,0-.11-.95,23.53,23.53,0,0,0-5.19-2,.45.45,0,0,1-.19-.11l-2.09-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.92,414.54c-3.25,0-8.77,0-9.91-.21L494.54,413c-.17,1,.23,1.7,1.35,1.7,1.75,0,5.73.58,6.6.68s9.41-.1,9.41-.1A5,5,0,0,0,511.92,414.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.85,415.93c-.7,0-1.22,0-1.41,0l-1-.12c-1.48-.2-4.25-.56-5.59-.56a1.87,1.87,0,0,1-1.5-.59,2,2,0,0,1-.34-1.7.49.49,0,0,1,.21-.32.45.45,0,0,1,.37-.08l7.46,1.31c.82.15,4.41.22,9.83.2h0a.51.51,0,0,1,.5.47,6.44,6.44,0,0,1,0,.85.5.5,0,0,1-.49.44C511.23,415.82,506.37,415.93,503.85,415.93Zm-1.55-1.05.25,0,.37,0ZM495,413.61a.68.68,0,0,0,.15.37.91.91,0,0,0,.73.24c1.41,0,4.11.36,5.72.57l.31,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.23,378.54l-.1,7.18s-3.49,4.36-4,5.91-1.75,15.23-1.75,15.72-.68,1.55-.68,2,.1,2.81.1,2.81a12.66,12.66,0,0,0,3.78-.78c2.23-.77,5.43-2,5.43-2a7.17,7.17,0,0,0-.09-1.94c-.2-.39-.78-.78-.59-1.07s5.44-15.81,5.44-15.81l1.26-3.5S504,377.86,501.23,378.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.83,412.7a.5.5,0,0,1-.5-.48s-.1-2.34-.1-2.83a3.59,3.59,0,0,1,.38-1.22,3.68,3.68,0,0,0,.3-.82c0-.65,1.27-14.28,1.77-15.87s3.29-5.1,4-5.94l.09-7a.5.5,0,0,1,.38-.48c2.91-.72,8.31,7.16,9.37,8.75a.53.53,0,0,1,0,.44l-1.26,3.5c-2.24,6.63-4.92,14.52-5.42,15.76l.17.21a2.38,2.38,0,0,1,.37.51,6.22,6.22,0,0,1,.15,2.2.49.49,0,0,1-.31.43s-3.24,1.27-5.45,2A13.32,13.32,0,0,1,494.83,412.7ZM501.72,379l-.09,6.71a.51.51,0,0,1-.11.31c-.95,1.19-3.51,4.55-3.89,5.75-.45,1.46-1.71,14.87-1.72,15.57a3.59,3.59,0,0,1-.38,1.22,3.68,3.68,0,0,0-.3.82c0,.33,0,1.57.08,2.28a14,14,0,0,0,3.14-.72c1.8-.62,4.26-1.58,5.11-1.91a5.77,5.77,0,0,0-.06-1.37,1.87,1.87,0,0,0-.24-.31c-.24-.28-.65-.76-.31-1.26s3.33-9.64,5.37-15.69l1.18-3.27C507.2,383.72,503.52,379.29,501.72,379Zm2.09,27.59a.16.16,0,0,1,0,.06Zm-2.68-20.88h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.2,358.17a66.67,66.67,0,0,1-.39,10.76c-.68,4-2.33,11.45-2.33,11.45s3.3,12.52,4.18,15,2.32,5.43,3.1,8.63,1.55,5.43,1.75,6-1.17,1.35-2.43,1.64-6.4-6.59-6.4-6.59a35.94,35.94,0,0,1-4-6c-1.55-3.1-4.37-8.63-4.56-11.06a21.48,21.48,0,0,0-1.16-5.23c-.39-1.27-7.57-10.87-9.9-15a31.52,31.52,0,0,1-3.1-9.31l3-6.31s5.92,4.37,11.84,5.24,9.31-.49,9.31-.49Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,412.22c-1.46,0-4.84-4.22-6.76-6.8a35.72,35.72,0,0,1-4-6.09l-.2-.42c-1.68-3.35-4.21-8.41-4.41-10.83a18.51,18.51,0,0,0-1-4.6l-.16-.53a66.48,66.48,0,0,0-3.92-5.95c-2.21-3.19-4.72-6.8-5.93-9a32,32,0,0,1-3.17-9.48.49.49,0,0,1,0-.29l3-6.3a.49.49,0,0,1,.33-.27.48.48,0,0,1,.42.08c.06,0,5.89,4.3,11.61,5.14s9-.44,9.06-.45a.5.5,0,0,1,.56.14l1.07,1.26a.49.49,0,0,1,.12.3,65.63,65.63,0,0,1-.4,10.88c-.62,3.67-2.09,10.38-2.3,11.35.34,1.28,3.32,12.54,4.13,14.88.3.87.67,1.78,1.06,2.75a43.73,43.73,0,0,1,2.06,5.93c.7,2.92,1.41,5,1.67,5.8l.06.18a.9.9,0,0,1-.09.76,4.5,4.5,0,0,1-2.7,1.53ZM490.5,358.53a30.9,30.9,0,0,0,3,9c1.19,2.14,3.69,5.73,5.88,8.9,2.46,3.54,3.86,5.58,4.05,6.23l.17.51a19.71,19.71,0,0,1,1,4.83c.18,2.23,2.76,7.38,4.3,10.46l.21.42a36.47,36.47,0,0,0,3.91,5.92c2.3,3.07,5.22,6.37,5.94,6.42a3.65,3.65,0,0,0,2-1.06l-.06-.11c-.27-.8-1-2.92-1.7-5.88a40,40,0,0,0-2-5.8c-.4-1-.77-1.9-1.08-2.79-.87-2.51-4-14.56-4.18-15.07a.49.49,0,0,1,0-.24c0-.07,1.65-7.5,2.32-11.42a65,65,0,0,0,.39-10.49l-.74-.87a21.09,21.09,0,0,1-9.22.39c-5.05-.74-10-3.91-11.57-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.81,368.93a66.67,66.67,0,0,0,.39-10.76l-1.07-1.27s-3.39,1.36-9.31.49S493,352.15,493,352.15l-3,6.31a31.52,31.52,0,0,0,3.1,9.31c1.08,1.93,3.19,5,5.19,7.9L496,369.22l1.18-2.58,2.8-1.1s4.17-2.14,5.72-1.75,6.79,16.59,6.79,16.59S514.13,372.91,514.81,368.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.48,380.88a.5.5,0,0,1-.47-.34c-2.45-7.58-5.54-15.74-6.48-16.28-1-.23-3.78.93-5.33,1.72l-2.66,1-1,2.22,2.21,6.26a.5.5,0,0,1-.88.45c-1.95-2.82-4.12-6-5.21-7.95a32,32,0,0,1-3.17-9.48.49.49,0,0,1,0-.29l3-6.3a.49.49,0,0,1,.33-.27.48.48,0,0,1,.42.08c.06,0,5.89,4.3,11.61,5.14s9-.44,9.06-.45a.5.5,0,0,1,.56.14l1.07,1.26a.49.49,0,0,1,.12.3,65.63,65.63,0,0,1-.4,10.88c-.67,3.94-2.31,11.39-2.33,11.47a.5.5,0,0,1-.46.39Zm-7.21-17.63a2.23,2.23,0,0,1,.54.06c1.45.36,4.53,9,6.58,15.16.53-2.46,1.46-6.89,1.93-9.62h0a65,65,0,0,0,.39-10.49l-.74-.87a21.09,21.09,0,0,1-9.22.39c-5.05-.74-10-3.91-11.57-5l-2.68,5.63a30.9,30.9,0,0,0,3,9c.68,1.22,1.8,2.93,3,4.73l-1-2.87a.47.47,0,0,1,0-.37l1.18-2.59a.49.49,0,0,1,.27-.26l2.8-1.1C500.15,364.89,503.41,363.25,505.27,363.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.86,410.65s-2.42-2.14-2.71-3-.2-4-1.65-4.95-4.27-2.71-6.11-.68-.39,6.21,1.16,8.54,5.05,4.66,7.08,4.85,3.11-1.94,3.11-2.91A3.07,3.07,0,0,0,522.86,410.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.89,415.91h-.31c-2.23-.21-5.85-2.68-7.45-5.07s-3.22-6.83-1.11-9.15,5.51-.23,6.76.6,1.5,2.78,1.68,4.19a7.14,7.14,0,0,0,.16,1,13.17,13.17,0,0,0,2.57,2.79l0,0a3.64,3.64,0,0,1,1,2.2,3.9,3.9,0,0,1-1.28,2.6A3,3,0,0,1,520.89,415.91Zm-6.38-14.34a2.24,2.24,0,0,0-1.75.78c-1.62,1.79-.27,5.71,1.21,7.92s4.75,4.45,6.71,4.63a2,2,0,0,0,1.61-.55,3,3,0,0,0,1-1.86,2.55,2.55,0,0,0-.72-1.48c-.45-.4-2.53-2.27-2.85-3.21a8.19,8.19,0,0,1-.21-1.2c-.14-1.16-.37-2.91-1.24-3.49A7.43,7.43,0,0,0,514.51,401.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.46,315.12,497,316.85s3.94,15.61,2.13,28.44-1.23,13.89-1.23,13.89,6.58,3.12,11.67,1.89,9.75-1.81,9.75-1.81-3-13.81-4.55-21.41c-.69-3.46,1.73-3.67,1.38-6.45a99.24,99.24,0,0,0-3.21-16S506,313.89,502.46,315.12Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,361.86a24.71,24.71,0,0,1-9.27-2.23.5.5,0,0,1-.22-.21c-.15-.29-.52-2.15,1.18-14.2,1.77-12.58-2.09-28.1-2.13-28.25a.5.5,0,0,1,.33-.6l5.42-1.73c3.63-1.25,10.5.17,10.79.24a.48.48,0,0,1,.37.33,102.05,102.05,0,0,1,3.22,16.12,4.47,4.47,0,0,1-.76,3.1,4.06,4.06,0,0,0-.62,3.32c1.5,7.51,4.52,21.27,4.55,21.4a.51.51,0,0,1-.08.4.5.5,0,0,1-.35.21,94.27,94.27,0,0,0-9.69,1.8A11.92,11.92,0,0,1,507,361.86Zm-8.61-3c1.19.52,6.77,2.81,11.12,1.75,4.06-1,7.88-1.55,9.26-1.74-.58-2.61-3.11-14.22-4.44-20.89a5,5,0,0,1,.73-4,3.5,3.5,0,0,0,.64-2.47,104.65,104.65,0,0,0-3.1-15.66c-1.34-.26-7-1.24-10-.21h0l-5,1.58c.63,2.68,3.67,16.63,2,28.18C498.25,355.44,498.31,358.18,498.38,358.83Zm4.08-43.71h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.23,314.54a12.72,12.72,0,0,0,2.55,6.09c2.13,2.46,6.08.41,6.65-1.73s-.08-7.36-.08-7.36-1.89,3.33-4.11,3.5A20,20,0,0,1,501.23,314.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.24,322.25a3.64,3.64,0,0,1-2.84-1.3,13.06,13.06,0,0,1-2.67-6.35.48.48,0,0,1,.17-.43.47.47,0,0,1,.44-.11,19.77,19.77,0,0,0,4.86.48c1.61-.12,3.23-2.38,3.71-3.24a.52.52,0,0,1,.54-.25.49.49,0,0,1,.39.43c0,.22.67,5.34.08,7.55a5,5,0,0,1-3.64,3.1A4.82,4.82,0,0,1,506.24,322.25Zm-4.4-7.07a11.71,11.71,0,0,0,2.31,5.12,2.88,2.88,0,0,0,2.9.86,4,4,0,0,0,2.9-2.39A21.6,21.6,0,0,0,510,313c-.81,1.06-2.17,2.46-3.72,2.58A18.92,18.92,0,0,1,501.84,315.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.56,300.18a22.45,22.45,0,0,1-3.49,3.59,14.34,14.34,0,0,1-3.79,2.29,31.84,31.84,0,0,0,.7,6.08c.6,2,1.79,3.59,3,4.09a5.37,5.37,0,0,0,4.29-.3,7.8,7.8,0,0,0,2.19-2.59l.9-1.8s2.89-1.29,2.89-2.29a8.63,8.63,0,0,0-.6-2.49l-1.49.4a2.11,2.11,0,0,1-2.2-1.1c-.79-1.39-.2-3-.4-3.49A19.13,19.13,0,0,0,506.56,300.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.72,317a5.2,5.2,0,0,1-1.94-.35c-1.36-.56-2.65-2.29-3.28-4.4a32.56,32.56,0,0,1-.72-6.22.5.5,0,0,1,.34-.48,14.56,14.56,0,0,0,3.64-2.21,22.09,22.09,0,0,0,3.4-3.5.49.49,0,0,1,.37-.2.48.48,0,0,1,.39.16,16.06,16.06,0,0,1,2.1,2.55,2.55,2.55,0,0,1,.05,1.06,3.92,3.92,0,0,0,.32,2.36,1.59,1.59,0,0,0,1.66.86l1.46-.39a.51.51,0,0,1,.6.29,9.42,9.42,0,0,1,.63,2.68c0,1.13-2,2.2-3,2.68l-.82,1.63a8.24,8.24,0,0,1-2.39,2.8A5.65,5.65,0,0,1,504.72,317Zm-4.93-10.65a29.39,29.39,0,0,0,.67,5.61,6,6,0,0,0,2.7,3.77,4.92,4.92,0,0,0,3.85-.27,7.46,7.46,0,0,0,2-2.39l.89-1.79a.49.49,0,0,1,.24-.23c1.34-.6,2.6-1.49,2.6-1.84a6.87,6.87,0,0,0-.41-1.89l-1.06.28a2.61,2.61,0,0,1-2.75-1.33,4.93,4.93,0,0,1-.45-2.94,3.52,3.52,0,0,0,0-.62,14.47,14.47,0,0,0-1.5-1.8,22.48,22.48,0,0,1-3.21,3.21A15.72,15.72,0,0,1,499.79,306.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.55,315.87s.58,13.29,1.26,22.41.29,19.59.29,19.59l-1.45,9.9s-3.4-.49-6.89-1.26a15.58,15.58,0,0,1-6.4-3.59s4.56-13.39,4.75-15.72-2.13-27.35-1.45-28.52S498.61,315.29,500.55,315.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.65,368.27h-.07s-3.46-.49-6.93-1.26a15.85,15.85,0,0,1-6.64-3.72.51.51,0,0,1-.13-.52c1.58-4.61,4.58-13.81,4.73-15.6.08-.91-.27-5.78-.64-10.94-.91-12.52-1.15-17.09-.75-17.79.87-1.47,8.41-3.67,10.48-3a.5.5,0,0,1,.35.46c0,.13.59,13.39,1.26,22.39s.3,19.55.29,19.65l-1.46,9.95A.5.5,0,0,1,500.65,368.27Zm-12.71-5.5a14.78,14.78,0,0,0,5.93,3.25c2.66.59,5.29,1,6.36,1.18l1.38-9.4c0-.05.37-10.5-.3-19.48-.6-8.15-1.14-19.77-1.24-22-2.23-.26-8.52,1.86-9,2.65-.3.89.41,10.72.87,17.22.39,5.42.73,10.11.65,11.1C492.43,349.43,488.64,360.69,487.94,362.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,315s2,9.7,3.88,15.13,9.21,20.18,10.86,26.1a66.33,66.33,0,0,1,2,9.41s-1-13.78-3.2-20.57-2.43-7.86-2.43-7.86l8.54,2.43a14.68,14.68,0,0,0-1.84-4.85c-1.26-1.75-1.75-1.94-2.43-3.59s-3.2-12.13-5-14a4.51,4.51,0,0,0-4.17-1.36C516.56,315.87,511,315,511,315Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.81,366.14a.51.51,0,0,1-.5-.45,65.42,65.42,0,0,0-2-9.33c-.92-3.31-3.74-9.61-6.23-15.17-2-4.38-3.82-8.52-4.62-10.9-1.84-5.4-3.88-15.09-3.9-15.19a.5.5,0,0,1,.57-.6c2.2.35,5.66.87,6.13.87l.31,0a4.77,4.77,0,0,1,4.21,1.52c1.31,1.31,2.74,6,4.22,11.08.4,1.4.75,2.62.94,3.06a6.93,6.93,0,0,0,1.32,2.13c.28.35.62.77,1,1.35a14.8,14.8,0,0,1,1.93,5.05.49.49,0,0,1-.15.47.51.51,0,0,1-.47.11l-7.7-2.19c.27,1,.87,3,2.19,7,2.23,6.78,3.19,20.13,3.23,20.69a.49.49,0,0,1-.45.53ZM511.67,315.6c.51,2.34,2.19,9.87,3.71,14.37.8,2.34,2.64,6.45,4.59,10.82,2.63,5.86,5.34,11.92,6.29,15.3,0,.13.07.25.1.38a68.3,68.3,0,0,0-2.23-11.24c-2.21-6.75-2.43-7.88-2.44-7.93a.5.5,0,0,1,.16-.46.48.48,0,0,1,.47-.11l7.73,2.2a12.56,12.56,0,0,0-1.58-3.85c-.41-.57-.73-1-1-1.31a8.05,8.05,0,0,1-1.47-2.38c-.2-.49-.54-1.67-1-3.16-1-3.52-2.73-9.42-4-10.65a3.83,3.83,0,0,0-3.41-1.24l-.4,0C516.67,316.37,513.23,315.85,511.67,315.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.24,333.79a22.66,22.66,0,0,0,2.48.06c.68-.06,2.78-1.3,4.21-.12a7.11,7.11,0,0,1,2.6,4.77c.13,1.8-.62,3.47-1.61,3.59a9.35,9.35,0,0,1-4.65-1.11,22.65,22.65,0,0,1-3.59-2.23,7.93,7.93,0,0,1-1.3-1.49A4.42,4.42,0,0,0,521.24,333.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.47,342.62a11.28,11.28,0,0,1-4.41-1.19,18.77,18.77,0,0,1-3.17-1.92,5,5,0,0,0-.46-.33,7.24,7.24,0,0,1-1.46-1.63.49.49,0,0,1-.08-.39.52.52,0,0,1,.23-.33,3.86,3.86,0,0,0,1.62-3.06.51.51,0,0,1,.17-.35.47.47,0,0,1,.36-.13,23.78,23.78,0,0,0,2.4.07,4.28,4.28,0,0,0,.6-.18c1-.34,2.68-.9,4,.17a7.63,7.63,0,0,1,2.78,5.12c.15,2.11-.77,4-2,4.12A4.12,4.12,0,0,1,528.47,342.62Zm-8.4-5.26a4.82,4.82,0,0,0,.86.95c.13.08.31.21.55.39a17.29,17.29,0,0,0,3,1.83,9,9,0,0,0,4.37,1.07c.62-.08,1.28-1.46,1.17-3.06a6.57,6.57,0,0,0-2.42-4.42c-.87-.72-2.11-.3-3,0a4.32,4.32,0,0,1-.83.22,18.18,18.18,0,0,1-2.07,0A5,5,0,0,1,520.07,337.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.56,331.93s-4.53.87-4.59,1.24a43.53,43.53,0,0,0,1.36,5.21c.13.18,4.16-.68,4.4-1.3S520.56,331.93,520.56,331.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.47,338.9a.62.62,0,0,1-.55-.24,34,34,0,0,1-1.44-5.57c.06-.35.12-.71,5-1.65a.49.49,0,0,1,.57.34c.68,2.14,1.43,4.83,1.17,5.48-.41,1-4.43,1.62-4.47,1.63Zm-1-5.48c.15.79.91,3.56,1.2,4.47a13,13,0,0,0,3.57-1,23.73,23.73,0,0,0-1-4.35A33.56,33.56,0,0,0,516.49,333.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.85 315.75 519.3 332.15 520.56 331.93 518.12 315.83 515.85 315.75",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.3,332.65a.5.5,0,0,1-.49-.4l-3.45-16.39a.52.52,0,0,1,.11-.43.56.56,0,0,1,.4-.18l2.27.08a.51.51,0,0,1,.48.43l2.43,16.1a.5.5,0,0,1-.41.57l-1.26.21Zm-2.83-16.37,3.22,15.3.3-.06-2.3-15.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.92,316.7a17.42,17.42,0,0,0-5.17,1.09c-1.65.87-1.81,1.26-1.81,1.26l-.23.71v.54s-3.06,15.46-3.22,16.16-1.49,3.69-1.33,5.34,3.45,3.29,4.23,3.53,3.22-.55,3.69-.71a6.87,6.87,0,0,0,2-1.57c.16-.31-.79-6-.79-6l2.36-10",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.76,345.87a1.88,1.88,0,0,1-.51-.06c-.52-.16-4.39-1.87-4.59-4a12.58,12.58,0,0,1,1-4.59c.14-.41.26-.73.3-.9.16-.7,3.18-16,3.21-16.15v-.45a.41.41,0,0,1,0-.16l.24-.71c.15-.39.86-.92,2-1.54a17.7,17.7,0,0,1,5.38-1.15.5.5,0,0,1,.07,1,16.76,16.76,0,0,0-5,1,4.92,4.92,0,0,0-1.61,1.06l-.16.53v.47c-.14.73-3.08,15.57-3.23,16.27a10.63,10.63,0,0,1-.34,1,12.55,12.55,0,0,0-1,4.15c.12,1.26,3,2.83,3.89,3.1a9.7,9.7,0,0,0,3.38-.7,8.08,8.08,0,0,0,1.72-1.28c0-.59-.4-3.33-.8-5.78a.41.41,0,0,1,0-.19l2.35-10a.5.5,0,0,1,1,.23L493.84,337c1,5.79.81,6.09.73,6.25a7.26,7.26,0,0,1-2.33,1.82A13.93,13.93,0,0,1,488.76,345.87Zm4.87-2.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,316.85s1.26,2.12,3.69,10,1.72,12.23,1.72,12.23a22,22,0,0,1-.94,2.83c-.47,1-9.2,5.85-9.2,5.85s1.44,1.68,1.36,1.91,8.16-6.74,8.16-6.74l2.43-4.63s-1.26-12.55-1.49-13.34-2.36-8.78-2.36-8.78Z",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.6,350.15a.36.36,0,0,1-.21-.09.49.49,0,0,1-.22-.38,13.43,13.43,0,0,0-1.24-1.63.49.49,0,0,1,.13-.76c4.14-2.29,8.64-5,9-5.63a23.17,23.17,0,0,0,.91-2.73h0s.64-4.35-1.72-12-3.63-9.83-3.64-9.85a.5.5,0,0,1,.33-.75l3.37-.7a.5.5,0,0,1,.59.36c0,.08,2.12,8,2.35,8.77s1.38,12.14,1.5,13.43a.45.45,0,0,1-.05.28l-2.43,4.63a.44.44,0,0,1-.12.15C492.2,349.17,491,350.15,490.6,350.15Zm-.52-2.28c.36.44.61.77.78,1,1.1-.87,4.06-3.35,6.45-5.36C495.33,344.9,492.07,346.76,490.08,347.87Zm4.7-30.66a74.26,74.26,0,0,1,3.42,9.46c2.44,7.86,1.78,12.28,1.75,12.46s-.15.58-.35,1.21l1.14-2.17c-.48-4.83-1.29-12.53-1.45-13.09s-1.78-6.62-2.24-8.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.82,336.62a58.51,58.51,0,0,0-5.88-.47c-1.41.08-2,.86-2.67,3.45s1,4.32,2.12,4.55a5.42,5.42,0,0,0,2.83-.23c.78-.24,4.78-2.59,5.33-2.75a12.85,12.85,0,0,1,2.35-.16,14.37,14.37,0,0,0,3.53-.39,1.14,1.14,0,0,0,.55-1.17c0-.4-.08-2-.08-2a3.24,3.24,0,0,0,.71-1.49.81.81,0,0,0-.55-.79s-2.67-1.25-3.92-1-3.53,2.51-3.53,2.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.35,344.75a5.09,5.09,0,0,1-1.06-.11,3.38,3.38,0,0,1-2.06-1.58,4.48,4.48,0,0,1-.44-3.59c.7-2.56,1.32-3.72,3.12-3.82a57.1,57.1,0,0,1,5.94.47h.55c.57-.55,2.43-2.27,3.65-2.5s3.94.92,4.22,1.06a1.28,1.28,0,0,1,.84,1.24,3.25,3.25,0,0,1-.7,1.65c0,.44.07,1.56.07,1.88a1.63,1.63,0,0,1-.8,1.61c-.74.42-3.75.45-3.78.45a9.87,9.87,0,0,0-2.21.14c-.22.07-1.33.68-2.22,1.16a29.45,29.45,0,0,1-3.11,1.59A7,7,0,0,1,489.35,344.75Zm-.08-8.11H489c-1.05.06-1.51.51-2.21,3.08a3.43,3.43,0,0,0,.32,2.81,2.32,2.32,0,0,0,1.41,1.12,4.87,4.87,0,0,0,2.58-.22c.37-.11,1.78-.89,2.92-1.5a20.61,20.61,0,0,1,2.42-1.25,10.91,10.91,0,0,1,2.49-.18,15.77,15.77,0,0,0,3.29-.32c.27-.16.29-.33.29-.74s-.07-2-.07-2a.48.48,0,0,1,.11-.34,2.7,2.7,0,0,0,.59-1.17.29.29,0,0,0-.2-.31,8.86,8.86,0,0,0-3.68-1c-.8.15-2.43,1.54-3.27,2.38a.5.5,0,0,1-.35.14h-.85S490.88,336.64,489.27,336.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.8,321.41s-5.6,12.06-6.2,13.42.17,9.93.43,11,3.39,4.25,5.43,5a13,13,0,0,0,5.26.26l.85-9.43-1-24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.39,351.79a9.34,9.34,0,0,1-3.11-.45c-2.13-.8-5.44-4.06-5.74-5.37-.2-.87-1.09-9.76-.4-11.34.59-1.35,6-12.93,6.21-13.43a.49.49,0,0,1,.14-.18l4.75-3.73a.49.49,0,0,1,.52-.07.51.51,0,0,1,.29.44l1,24-.85,9.49a.5.5,0,0,1-.42.45A17.61,17.61,0,0,1,449.39,351.79Zm-2.19-30.06c-.56,1.21-5.58,12-6.14,13.3s.2,9.6.45,10.72c.2.84,3.11,3.9,5.12,4.65a11.52,11.52,0,0,0,4.63.28l.81-9-1-23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.55,328l1.25,3.08a17.38,17.38,0,0,1,3.33,5.48c1.41,3.58,7,14.3,7,14.3s2.66,1.92,3,2.66a10.73,10.73,0,0,1,.25,4.58c-.33.58-2.41.58-2.41.58l-.83-1.83a11.34,11.34,0,0,1-2.41-2.08,17.75,17.75,0,0,1-.33-3.82l-7.07-8.4c-1.75-2.08-4.74-6-5.32-6.73s-2.5-3.66-2.5-3.66l-.66-3.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.94,359.21a.51.51,0,0,1-.45-.29l-.78-1.71a9.94,9.94,0,0,1-2.46-2.18,14.28,14.28,0,0,1-.38-3.87c-.79-.94-5.36-6.36-6.95-8.26S476,338,475,336.68l-.41-.53c-.58-.75-2.43-3.57-2.51-3.69a.42.42,0,0,1-.08-.18l-.66-3.75a.46.46,0,0,1,.1-.39.5.5,0,0,1,.36-.19l6.73-.42a.51.51,0,0,1,.5.31l1.21,3a18.11,18.11,0,0,1,3.36,5.58c1.32,3.32,6.33,13,6.91,14.15.74.54,2.72,2,3.06,2.79s.69,4.21.23,5S491.65,359.21,490.94,359.21ZM473,332c.32.48,1.91,2.89,2.41,3.54l.42.53c1,1.33,3.41,4.43,4.89,6.19l7.07,8.39a.58.58,0,0,1,.12.33,15.58,15.58,0,0,0,.28,3.6,10.37,10.37,0,0,0,2.24,1.89.41.41,0,0,1,.17.2l.7,1.53a3.76,3.76,0,0,0,1.67-.33,12,12,0,0,0-.28-4.11,14.33,14.33,0,0,0-2.83-2.46.43.43,0,0,1-.15-.18c-.23-.43-5.6-10.78-7-14.34a17.13,17.13,0,0,0-3.21-5.32.39.39,0,0,1-.11-.17l-1.11-2.74-5.82.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.94,358.71a9.64,9.64,0,0,0,1-2.08c0-.42-.75-1.16-1-1.41a10.29,10.29,0,0,1-.75-2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.94,359.21a.48.48,0,0,1-.26-.07.51.51,0,0,1-.17-.69,9.34,9.34,0,0,0,.93-1.84,3.56,3.56,0,0,0-.85-1,7,7,0,0,1-.88-2.22.51.51,0,0,1,.35-.62.49.49,0,0,1,.61.34,10.91,10.91,0,0,0,.64,1.8c.8.8,1.13,1.31,1.13,1.75a7.34,7.34,0,0,1-1.07,2.34A.51.51,0,0,1,490.94,359.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.17,381.25l-.3,4.37a20,20,0,0,0-2.16,5.5c-.42,2.52-3.71,11.95-4.49,14.05s-2.69,4.37-2.45,5.32,2.51,1.86,2.51,1.86,2.28.54,2.52.66,2.81,2,5,2.33,3.36-.24,3.24-.78-2.28-2.09-2.7-2.75-3.29-4.85-3.47-5.33,3.41-7.69,6-11.64a48.28,48.28,0,0,0,4.13-8l1.26-6.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,415.93a9.31,9.31,0,0,1-1.25-.09,13.45,13.45,0,0,1-5-2.24l-.23-.15c-.16-.07-1.35-.37-2.39-.61-.49-.19-2.6-1.08-2.89-2.23-.19-.74.4-1.75,1.15-3a19.15,19.15,0,0,0,1.32-2.59c.91-2.44,4.07-11.55,4.47-13.95a19.77,19.77,0,0,1,2.16-5.57l.29-4.26a.49.49,0,0,1,.43-.46l9.1-1.2a.5.5,0,0,1,.43.16.48.48,0,0,1,.13.43l-1.26,6.77a48.35,48.35,0,0,1-4.2,8.2,73.49,73.49,0,0,0-5.9,11.27c.28.53,1.78,2.77,2.53,3.87l.86,1.29a8.7,8.7,0,0,0,1.18,1.15c1,.91,1.48,1.35,1.58,1.77a.93.93,0,0,1-.24.81A3.21,3.21,0,0,1,462,415.93Zm-1.37-34.24-.27,4a.57.57,0,0,1-.07.22,19.47,19.47,0,0,0-2.1,5.34c-.43,2.61-3.85,12.34-4.51,14.13a19.62,19.62,0,0,1-1.4,2.74c-.5.86-1.13,1.94-1,2.29s1.36,1.18,2.21,1.51,2.31.55,2.56.68l.32.2a12.83,12.83,0,0,0,4.55,2.09,4.23,4.23,0,0,0,2.64-.22,10.15,10.15,0,0,0-1.23-1.19,9,9,0,0,1-1.36-1.36l-.84-1.27c-1.68-2.49-2.55-3.82-2.68-4.15-.34-.93,4.21-9.29,6-12.1a47.45,47.45,0,0,0,4.08-7.92l1.11-6Zm-.77,3.93h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.06,414.56c-.12-.53-2.28-2.09-2.7-2.75s-3.29-4.85-3.47-5.33c0,0-.84.12-1,.72s-.42,1.5-.42,1.5A22.61,22.61,0,0,1,453,407l-.48-.37c-.87,1.63-2,3.16-1.79,3.9.24,1,2.51,1.86,2.51,1.86s2.28.54,2.52.66,2.81,2,5,2.33S464.18,415.1,464.06,414.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,415.93a9.31,9.31,0,0,1-1.25-.09,13.45,13.45,0,0,1-5-2.24l-.23-.15c-.16-.07-1.35-.37-2.39-.61-.49-.19-2.6-1.08-2.89-2.23-.19-.74.4-1.75,1.15-3,.23-.39.46-.8.69-1.21a.45.45,0,0,1,.33-.25.44.44,0,0,1,.4.08l.5.38A17.88,17.88,0,0,0,456.2,408a7.79,7.79,0,0,0,.24-.92,1.59,1.59,0,0,1,1.38-1.11.51.51,0,0,1,.54.32c.14.33,1.78,2.77,2.57,3.94l.86,1.29a8.7,8.7,0,0,0,1.18,1.15c1,.91,1.48,1.35,1.58,1.77h0a.93.93,0,0,1-.24.81A3.21,3.21,0,0,1,462,415.93Zm-9.29-8.59-.43.74c-.5.86-1.13,1.94-1,2.29s1.36,1.18,2.21,1.51,2.31.55,2.56.68l.32.2a12.83,12.83,0,0,0,4.55,2.09,4.23,4.23,0,0,0,2.64-.22,10.15,10.15,0,0,0-1.23-1.19,9,9,0,0,1-1.36-1.36l-.84-1.27c-1.27-1.89-2.08-3.1-2.45-3.73a.39.39,0,0,0-.23.22c-.12.62-.42,1.52-.43,1.56a.51.51,0,0,1-.27.29.5.5,0,0,1-.4,0,21.89,21.89,0,0,1-3.59-1.81Zm10.86,7.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.26,381.44l1.4,3.39s-.82,6.06,1.17,9.91,5.36,15.06,5.71,15.88,1,4.2,1.64,4.2a13.53,13.53,0,0,0,2.8-1.17,26.93,26.93,0,0,0,4.43-2.22c2-1.28,2.8-4,2.1-4.9s-2.22-.12-3,.23-3.5-.11-4.09-.23l-.58-.12s-.58-5.25-1.05-7.7-.93-8.28-1.28-11.55-1.05-7.59-1.05-7.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.18,415.32c-.71,0-1.05-.94-1.71-3.25-.15-.53-.29-1-.39-1.26s-.32-.93-.8-2.39c-1.2-3.71-3.44-10.61-4.9-13.45-1.89-3.67-1.35-9.12-1.23-10.08l-1.35-3.26a.51.51,0,0,1,0-.42.53.53,0,0,1,.34-.26l8.16-1.86a.47.47,0,0,1,.4.07.52.52,0,0,1,.21.33c0,.05.71,4.37,1.05,7.62.1.93.21,2.07.33,3.28.29,3,.62,6.5.95,8.23.4,2.09.87,6.14,1,7.38l.22,0a11.25,11.25,0,0,0,3.79.26l.25-.11c.94-.42,2.51-1.12,3.38,0a2.43,2.43,0,0,1,.29,1.87,6,6,0,0,1-2.52,3.75,27.25,27.25,0,0,1-4.53,2.27A11,11,0,0,1,469.18,415.32ZM460,381.8l1.17,2.83a.47.47,0,0,1,0,.26c0,.06-.77,6,1.12,9.62,1.5,2.91,3.75,9.87,5,13.6.38,1.19.68,2.12.76,2.31s.27.79.44,1.38a13.41,13.41,0,0,0,.86,2.5,17,17,0,0,0,2.44-1.09,28.23,28.23,0,0,0,4.4-2.2,4.92,4.92,0,0,0,2.07-3.08,1.54,1.54,0,0,0-.1-1.1c-.36-.48-1.27-.13-2.17.28l-.27.11c-1,.45-4-.13-4.37-.2l-.59-.12a.5.5,0,0,1-.4-.43c0-.05-.58-5.26-1-7.66-.34-1.78-.67-5.26-1-8.33-.11-1.2-.22-2.34-.32-3.27-.27-2.55-.77-5.78-1-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.46,407.81l.47.82s-2.69,2.34-3.39,2c.35.81,1,4.2,1.64,4.2a13.53,13.53,0,0,0,2.8-1.17,26.93,26.93,0,0,0,4.43-2.22c2-1.28,2.8-4,2.1-4.9s-2.22-.12-3,.23-3.5-.11-4.09-.23l-.58-.12A1.09,1.09,0,0,0,470.46,407.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.18,415.32c-.71,0-1.05-.94-1.71-3.25-.15-.53-.29-1-.39-1.26a.5.5,0,0,1,.69-.64h0a9.06,9.06,0,0,0,2.52-1.65l-.26-.46a1.54,1.54,0,0,1,.49-2.05.53.53,0,0,1,.39-.09l.58.12a11.25,11.25,0,0,0,3.79.26l.25-.11c.94-.42,2.51-1.12,3.38,0a2.43,2.43,0,0,1,.29,1.87,6,6,0,0,1-2.52,3.75,27.25,27.25,0,0,1-4.53,2.27A11,11,0,0,1,469.18,415.32Zm-1-4.28c.06.23.14.48.22.76a13.41,13.41,0,0,0,.86,2.5,17,17,0,0,0,2.44-1.09,28.23,28.23,0,0,0,4.4-2.2,4.92,4.92,0,0,0,2.07-3.08,1.54,1.54,0,0,0-.1-1.1c-.36-.48-1.27-.13-2.17.28l-.27.11c-1,.45-4-.13-4.37-.2L471,407a.54.54,0,0,0-.07.62h0l.47.81a.52.52,0,0,1-.1.63A10.88,10.88,0,0,1,468.22,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.37,348.82s-.66,5.48.67,9.31,2.57,7.23,2.57,7.23L457.52,383l10.31-1.17a3.15,3.15,0,0,0,2.16.33c1.5-.16,1.91-.25,1.91-.25s.92-5,1.58-9.22,1.08-16.47.67-19-1.08-7.15-1.08-7.15-3.16,2.57-10.65,2.08A82.47,82.47,0,0,1,450,346.9Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.52,383.49a.5.5,0,0,1-.48-.37l-4.91-17.62h0s-1.24-3.4-2.57-7.21-.71-9.31-.68-9.54a.36.36,0,0,1,0-.1l.66-1.91a.5.5,0,0,1,.59-.32,84,84,0,0,0,12.31,1.65c7.16.48,10.26-1.95,10.29-2a.53.53,0,0,1,.5-.08.49.49,0,0,1,.31.4s.67,4.56,1.08,7.14,0,14.88-.66,19.19-1.58,9.19-1.59,9.24a.48.48,0,0,1-.39.4s-.45.09-1.95.26a4.08,4.08,0,0,1-2.33-.31l-10.14,1.14Zm-7.66-34.56c-.06.56-.56,5.56.65,9,1.33,3.82,2.57,7.23,2.57,7.23l4.81,17.25,9.88-1.12a.56.56,0,0,1,.36.1h0a2.93,2.93,0,0,0,1.8.24l1.54-.19c.22-1.21,1-5.33,1.52-8.87.65-4.14,1.08-16.32.66-18.88-.31-1.93-.76-5-1-6.39-1.32.75-4.58,2.12-10.29,1.74a90.67,90.67,0,0,1-12-1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.83,382.32a.51.51,0,0,1-.5-.45l-2.08-20.7a.52.52,0,0,1,.11-.36l3.32-4.24a.5.5,0,0,1,.79.62l-3.2,4.08,2.06,20.5a.51.51,0,0,1-.45.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,357.21a.51.51,0,0,1-.43-.23.5.5,0,0,1,.17-.69,12.11,12.11,0,0,0,1.82-1.43,8.38,8.38,0,0,0,1.19-3.23.5.5,0,0,1,.58-.4.51.51,0,0,1,.4.59c-.05.29-.55,2.84-1.47,3.75a12.52,12.52,0,0,1-2,1.57A.48.48,0,0,1,453,357.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.28,364.53a.5.5,0,0,1-.48-.34l-.75-2.19a.51.51,0,0,1,.32-.63.5.5,0,0,1,.63.31l.75,2.19a.5.5,0,0,1-.31.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.16,361.27a.49.49,0,0,1-.47-.34l-2.46-7.21a.5.5,0,1,1,.94-.33l2.47,7.22a.5.5,0,0,1-.32.63A.41.41,0,0,1,454.16,361.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.44,369.27a.5.5,0,0,1-.14-1l8-2.45,0-.33L454.09,368a.5.5,0,0,1-.29-1l8.73-2.66a.52.52,0,0,1,.42.06.51.51,0,0,1,.22.36l.17,1.33a.5.5,0,0,1-.35.54l-8.4,2.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.38,380.35a3.15,3.15,0,0,1-.44,0,.5.5,0,1,1,.15-1,2.5,2.5,0,0,0,1.42-.25.5.5,0,0,1,.41.92A3.89,3.89,0,0,1,460.38,380.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.1,379.14a.5.5,0,0,1-.33-.88,4.24,4.24,0,0,0,1.57-2.43c0-1.08-.76-5.47-1.16-7.64a.5.5,0,1,1,1-.18c0,.26,1.18,6.38,1.18,7.82a5,5,0,0,1-1.91,3.18A.48.48,0,0,1,463.1,379.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.71,307.79s-11.46,6-11.62,6.38-.92,30.85-.92,31.16-.15,3.76.31,4.23,9.61,2,15.31,1.46,8.3-2.08,8.61-2.77a26,26,0,0,0,.62-3.92l-.54-14.24a9.12,9.12,0,0,0,2.46-.07c1-.23,4.08-1.39,4.08-1.39s-2.85-9.15-3.31-11.77-1.31-6.3-2.08-7.07,1.23-.7-4-1.54A37.07,37.07,0,0,0,461.71,307.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.14,351.63c-5.41,0-12.39-1.1-13-1.72-.34-.34-.55-1.21-.46-4.37v-.21c0-.29.75-30.83,1-31.35.08-.2.22-.55,11.85-6.64a.48.48,0,0,1,.18,0,37.53,37.53,0,0,1,9,.46c3.73.61,4.2.73,4.21,1.55a.14.14,0,0,0,.07.13c1,1,1.95,5.89,2.21,7.35.45,2.55,3.27,11.61,3.29,11.7a.5.5,0,0,1-.3.62c-.12,0-3.12,1.17-4.14,1.4a7.74,7.74,0,0,1-2.05.13l.52,13.68a24.49,24.49,0,0,1-.66,4.14c-.41.93-3.16,2.51-9,3.07C464,351.59,463.1,351.63,462.14,351.63Zm-12.31-2.44a53.2,53.2,0,0,0,14.91,1.33c5.58-.53,8-2,8.2-2.48a24.06,24.06,0,0,0,.58-3.76L473,330.11a.5.5,0,0,1,.55-.51,8.87,8.87,0,0,0,2.3-.07c.73-.17,2.69-.88,3.57-1.2-.59-1.9-2.78-9.07-3.18-11.38-.62-3.48-1.42-6.28-1.94-6.81a1.06,1.06,0,0,1-.36-.73,29.07,29.07,0,0,0-3.37-.67,38,38,0,0,0-8.7-.46c-4,2.1-10.37,5.49-11.3,6.15-.15,1.91-.88,30.64-.88,30.9v.23A12.43,12.43,0,0,0,449.83,349.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.69,311.4s3.91,10,4.59,15.87-6.62,9.76-9,11.55-1.87,2-1.87,2l.43,3.48a36.71,36.71,0,0,0,10.61-8.82c4.34-5.57,3.22-10,3.05-11s-5.17-14.09-5.17-14.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.84,344.83a.69.69,0,0,1-.24-.05.52.52,0,0,1-.26-.39l-.41-3.39a.47.47,0,0,1-.06-.19c0-.39.19-1,2.11-2.39.34-.26.78-.56,1.29-.9,3-2,8.06-5.46,7.51-10.19-.66-5.73-4.51-15.65-4.55-15.75a.46.46,0,0,1,0-.38.48.48,0,0,1,.27-.27l2.63-1a.52.52,0,0,1,.39,0,.55.55,0,0,1,.26.28c.52,1.34,5,13.15,5.21,14.19l0,.18c.7,3.85-.37,7.63-3.19,11.24a36.83,36.83,0,0,1-10.77,9A.48.48,0,0,1,448.84,344.83Zm.06-4.09a.43.43,0,0,1,0,.05l.33,2.74a36.23,36.23,0,0,0,9.81-8.33c4-5.1,3.24-9.13,3-10.45l0-.2c-.11-.69-3-8.29-5-13.52l-1.7.65c.78,2.07,3.83,10.33,4.43,15.53s-4.95,9.11-7.94,11.14c-.49.33-.92.62-1.25.87A7.11,7.11,0,0,0,448.9,340.74Zm-.26-.33Zm0,0Zm0,0h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.09,311.94s-4.38,1.15-5.53,2.92S443,339.79,443,340.71s.61,1.08,1.07,1.31,5.08-1.16,6.85-2.16,9.92-5.84,10.23-6.07,2.08-1,2.39-1.93a5.37,5.37,0,0,0,.23-1.92c0-.23.15-1.23.15-1.61a4.33,4.33,0,0,0-.15-.93s.53-1.07-.16-1.38-.84,0-1.61.15-3.31.46-3.31.46-.46,0-.62,1.39.08,3.07-.07,3.54-6.16,1.77-6.16,1.77l3-11.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.23,342.52a.84.84,0,0,1-.36-.06l-.16-.07a1.7,1.7,0,0,1-1.19-1.68c0-1.28,4.43-24.3,5.62-26.12s5.64-3.08,5.83-3.13a.5.5,0,1,1,.25,1c-1.17.31-4.39,1.4-5.25,2.72-1,1.57-5.41,24.25-5.45,25.57,0,.49.2.58.61.77l.19.09a25.82,25.82,0,0,0,6.37-2.14c1.91-1.08,9.83-5.8,10.18-6.05l.44-.26c.48-.26,1.59-.88,1.77-1.41a4.53,4.53,0,0,0,.21-1.64v-.13c0-.11,0-.38.06-.68s.09-.73.09-.93a4.17,4.17,0,0,0-.13-.79.45.45,0,0,1,0-.36,1.2,1.2,0,0,0,.13-.67.66.66,0,0,0-.71,0,3.84,3.84,0,0,1-.65.18c-.71.14-2.82.41-3.26.46a2.06,2.06,0,0,0-.26.95,15.11,15.11,0,0,0,0,2.12,5.08,5.08,0,0,1-.07,1.52c-.1.3-.24.74-6.52,2.1a.49.49,0,0,1-.47-.14.5.5,0,0,1-.12-.47l3-11.77a.5.5,0,0,1,1,.25l-2.8,11a37.15,37.15,0,0,0,5-1.37c0-.23,0-.69,0-1.07a15.72,15.72,0,0,1,0-2.26c.18-1.65.84-1.83,1.11-1.83,0,0,2.47-.3,3.21-.45a3.19,3.19,0,0,0,.51-.15,1.64,1.64,0,0,1,1.41,0,1.06,1.06,0,0,1,.57.62,1.86,1.86,0,0,1-.1,1.26,3.72,3.72,0,0,1,.13.89,10.42,10.42,0,0,1-.1,1c0,.26,0,.48,0,.57v.1a5.43,5.43,0,0,1-.26,2c-.3.91-1.51,1.58-2.23,2a2,2,0,0,0-.33.19c-.37.28-8.76,5.24-10.28,6.11A24.32,24.32,0,0,1,444.23,342.52Zm13.42-11.29Zm1.16-4.11h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.63,326c-.69-.31-.84,0-1.61.15s-3.31.46-3.31.46-.46,0-.62,1.39.08,3.07-.07,3.54-6.16,1.77-6.16,1.77l.8-3.14c-2.57.82-5.9.31-7.71-.08-1.06,5.37-1.93,10.19-1.93,10.6,0,.92.61,1.08,1.07,1.31s5.08-1.16,6.85-2.16,9.92-5.84,10.23-6.07,2.08-1,2.39-1.93a5.37,5.37,0,0,0,.23-1.92c0-.23.15-1.23.15-1.61a4.33,4.33,0,0,0-.15-.93S464.32,326.33,463.63,326Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.23,342.52a.84.84,0,0,1-.36-.06l-.16-.07a1.7,1.7,0,0,1-1.19-1.68c0-.53,1-6,1.94-10.69a.46.46,0,0,1,.22-.32.5.5,0,0,1,.38-.08c1.72.38,5,.88,7.45.1a.49.49,0,0,1,.49.11.5.5,0,0,1,.15.49l-.6,2.34a37.15,37.15,0,0,0,5-1.37c0-.23,0-.69,0-1.07a15.72,15.72,0,0,1,0-2.26c.18-1.65.84-1.83,1.11-1.83,0,0,2.47-.3,3.21-.45a3.19,3.19,0,0,0,.51-.15,1.64,1.64,0,0,1,1.41,0,1.06,1.06,0,0,1,.57.62,1.86,1.86,0,0,1-.1,1.26,3.72,3.72,0,0,1,.13.89,10.42,10.42,0,0,1-.1,1c0,.26,0,.48,0,.57v.1a5.43,5.43,0,0,1-.26,2c-.3.91-1.51,1.58-2.23,2a2,2,0,0,0-.33.19c-.37.28-8.76,5.24-10.28,6.11A24.32,24.32,0,0,1,444.23,342.52Zm1.11-11.82c-1.1,5.58-1.81,9.64-1.82,10s.2.58.61.77l.19.09a25.82,25.82,0,0,0,6.37-2.14c1.91-1.08,9.83-5.8,10.18-6.05l.44-.26c.48-.26,1.59-.88,1.77-1.41a4.53,4.53,0,0,0,.21-1.64v-.13c0-.11,0-.38.06-.68s.09-.73.09-.93a4.17,4.17,0,0,0-.13-.79.45.45,0,0,1,0-.36,1.2,1.2,0,0,0,.13-.67l0,0a.67.67,0,0,0-.67,0,3.84,3.84,0,0,1-.65.18c-.71.14-2.82.41-3.26.46a2.06,2.06,0,0,0-.26.95,15.11,15.11,0,0,0,0,2.12,5.08,5.08,0,0,1-.07,1.52c-.1.3-.24.74-6.52,2.1a.49.49,0,0,1-.47-.14.5.5,0,0,1-.12-.47l.59-2.31A17.82,17.82,0,0,1,445.34,330.7Zm13.47-3.58h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.86,
    y1: 333.33,
    x2: 445.17,
    y2: 335.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.17,335.75a.5.5,0,0,1-.14-1l6.69-1.93a.5.5,0,0,1,.28,1l-6.69,1.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.74,320.56a9.22,9.22,0,0,0-.34-1.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.74,321.06a.5.5,0,0,1-.49-.43,9.1,9.1,0,0,0-.33-1.46.51.51,0,0,1,.33-.63.5.5,0,0,1,.63.33,12.41,12.41,0,0,1,.36,1.62.5.5,0,0,1-.43.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.48,330.09a48.57,48.57,0,0,0,.43-7.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.48,330.59h-.07A.5.5,0,0,1,473,330a47.12,47.12,0,0,0,.43-7.62.5.5,0,1,1,1,0,47,47,0,0,1-.43,7.81A.49.49,0,0,1,473.48,330.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.55,296.48s.24,3.15.16,3.92-.77,1.16-.77,1.93,1.08,2.15.69,2.69a4.44,4.44,0,0,1-1.15,1s-1,2.69-1.39,3.46-1.38,1.08-3,.85a25.27,25.27,0,0,1-3.3-.77s.3,4.07-1.31,5.77-4,1-5.16-1.7a21.48,21.48,0,0,1-1.46-4.84l1.62-6s-.69-1.16-.08-5,5.23-5.31,7.31-5.62S476.86,292.63,477.55,296.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.5,316.74a3.27,3.27,0,0,1-.54,0,4.51,4.51,0,0,1-3.1-2.87,21.61,21.61,0,0,1-1.49-5,.44.44,0,0,1,0-.2l1.57-5.83c-.2-.51-.55-2,0-5.12.63-3.95,5.15-5.65,7.73-6s7.68.66,8.41,4.71v.05c0,.33.24,3.22.16,4a2.43,2.43,0,0,1-.47,1.14,1.36,1.36,0,0,0-.3.74,3.33,3.33,0,0,0,.35,1c.31.7.64,1.44.25,2a4.73,4.73,0,0,1-1.15,1c-.23.6-1,2.67-1.35,3.35s-1.24,1.45-3.52,1.12a23.54,23.54,0,0,1-2.71-.59c0,1.3-.14,4-1.47,5.44A3.23,3.23,0,0,1,465.5,316.74Zm-4.13-7.93a22.23,22.23,0,0,0,1.41,4.63,3.51,3.51,0,0,0,2.36,2.27,2.14,2.14,0,0,0,2-.73c1.44-1.51,1.17-5.35,1.17-5.39a.52.52,0,0,1,.19-.43.5.5,0,0,1,.46-.08,23.67,23.67,0,0,0,3.22.75c.94.13,2.13.14,2.49-.58s1.35-3.38,1.36-3.41a.51.51,0,0,1,.21-.25,4.2,4.2,0,0,0,1-.86,3.85,3.85,0,0,0-.36-1,3.87,3.87,0,0,1-.43-1.4,2.24,2.24,0,0,1,.46-1.27,1.7,1.7,0,0,0,.31-.71c.06-.59-.09-2.92-.15-3.81-.64-3.43-5.39-4.15-7.28-3.87-2.3.34-6.34,1.82-6.88,5.2s0,4.66,0,4.67a.55.55,0,0,1,0,.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.79,309.56l-1.93-1.31,1.46,4.77S469.4,310.63,468.79,309.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.32,313.52h0a.52.52,0,0,1-.44-.36l-1.47-4.77a.51.51,0,0,1,.76-.56l1.93,1.31a.5.5,0,0,1,.15.17c.72,1.26-.32,3.65-.44,3.91A.51.51,0,0,1,468.32,313.52Zm-.56-4.06.59,1.92a2.94,2.94,0,0,0,0-1.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.56,302.17s1.92.69,2.15.23.08-1.23.46-1.46,2.08.23,2.31-.77-1.23-3.08-.62-3.31,4.08.23,4.77.23,1.23-.23,1.62-2a3,3,0,0,0-1.77-3.15c-.46-.15-2.93-2.61-6.62-2.69s-7.61,1.61-8.54,5a14,14,0,0,0,.47,8,9.26,9.26,0,0,1,.61,2.23,1.84,1.84,0,0,0,1.62.92C464.86,305.4,467.56,302.17,467.56,302.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,305.9a2.26,2.26,0,0,1-2.1-1.3,2.64,2.64,0,0,1-.07-.35,7.08,7.08,0,0,0-.5-1.76,14.53,14.53,0,0,1-.51-8.37c1-3.8,5.37-5.47,9-5.37a11.11,11.11,0,0,1,6.36,2.43,4.19,4.19,0,0,0,.42.29,3.51,3.51,0,0,1,2.09,3.73c-.38,1.72-1,2.39-2.11,2.39-.23,0-.76,0-1.39-.1-.81-.08-2.39-.22-3-.19.06.22.19.57.29.82a4,4,0,0,1,.44,2.16c-.24,1.07-1.4,1.08-2.1,1.08a2,2,0,0,0-.47,0,1.75,1.75,0,0,1,0,.41,2.58,2.58,0,0,1-.2.83c-.11.2-.4.79-2.44.13C466.63,304,464.89,305.9,464,305.9Zm5.61-16.15c-3.2,0-6.95,1.42-7.82,4.63a13.58,13.58,0,0,0,.41,7.62,7.44,7.44,0,0,1,.61,2.06,2.6,2.6,0,0,0,.06.3,1.49,1.49,0,0,0,1.13.54c.42-.07,2-1.64,3.15-3a.5.5,0,0,1,.55-.15,5.07,5.07,0,0,0,1.58.36,3.45,3.45,0,0,0,.07-.39,1.43,1.43,0,0,1,.54-1.16,1.88,1.88,0,0,1,.94-.15c.7,0,1.08-.05,1.14-.3a3.93,3.93,0,0,0-.4-1.58c-.28-.72-.5-1.28-.31-1.71a.71.71,0,0,1,.41-.37,12,12,0,0,1,3.65.09c.58.06,1.08.1,1.29.1.38,0,.78,0,1.13-1.6a2.55,2.55,0,0,0-1.44-2.57,3.1,3.1,0,0,1-.68-.43,10.2,10.2,0,0,0-5.79-2.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.17,303.17s-.23-3.23-1.69-3-1.54,1.08-1.23,2.92a2.31,2.31,0,0,0,2.07,2.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.32,305.67a2.82,2.82,0,0,1-2.57-2.49c-.21-1.28-.24-2.13.2-2.74a2,2,0,0,1,1.45-.76,1.36,1.36,0,0,1,1.08.29c1,.78,1.17,2.92,1.19,3.17a.5.5,0,0,1-.46.53.52.52,0,0,1-.54-.46,4.3,4.3,0,0,0-.81-2.46.33.33,0,0,0-.3-.08c-.62.09-.76.29-.8.35-.24.33-.18,1,0,2a1.81,1.81,0,0,0,1.59,1.66.51.51,0,0,1,.49.51A.5.5,0,0,1,467.32,305.67Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.9,379.06s2.3-.64,3.71-1.16,2.74-.67,2.82-.08-2.08,3.56-4.15,5.26-2.67,1.78-3.63,1.41-1.39-4.11-1.39-4.11A10,10,0,0,0,305.9,379.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.47,385.17a2.64,2.64,0,0,1-1-.21c-1.13-.43-1.57-3.31-1.7-4.53a.48.48,0,0,1,.33-.52,9.15,9.15,0,0,0,2.45-1.21.45.45,0,0,1,.21-.12s2.3-.65,3.68-1.15c.66-.25,2.3-.77,3.07-.3a.85.85,0,0,1,.41.63c.12,1-2.41,4.14-4.33,5.71C307.12,384.68,306.29,385.17,305.47,385.17Zm-1.66-4.46c.22,1.64.68,3.17,1,3.31.67.26,1,.4,3.14-1.32A17.09,17.09,0,0,0,311.9,378a4.69,4.69,0,0,0-2.12.42c-1.25.46-3.15,1-3.64,1.14A9.4,9.4,0,0,1,303.81,380.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,314.52a19,19,0,0,0-.93,6.82c0,4.65.23,9.92.23,9.92s-3,4.8-1.63,12.16,3.33,16,3.33,16-4.72,2.71-5.73,4l-7.44,9.76,3.1,2.25s4.88-4.73,6.2-5.81,5-3.8,6-4.65,2.17-1.4,2.56-2.33,1.55-13.09,1.55-13.09,3.1,3.1,3.56,3.8,1.55,3.09,1.55,3.09a48.22,48.22,0,0,0,.31,6.13c.39,3.09,3.18,13.4,3.34,14.17s.77,3.18,1.31,3.57a2.46,2.46,0,0,0,2.25-.47c.15-.31.39-.85.39-.85s-.93-7.44-.93-8.37.07-5.11.07-8.05-.77-8.6-.77-8.91a86,86,0,0,0-1.39-9.38c-.62-2.17-3.57-10.54-3.57-10.54l-.46-1.62-.16-3.26s2.95-7.67,2.95-9.91a4.67,4.67,0,0,0-3.18-4.5c-1.78-.62-9.53-1.62-10.38-1.39A7.11,7.11,0,0,0,286,314.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.81,381a1.51,1.51,0,0,1-.84-.22c-.86-.62-1.51-3.85-1.51-3.88,0-.19-.24-1-.52-2-.88-3.43-2.53-9.81-2.82-12.17a47,47,0,0,1-.32-6.08c-.33-.73-1.12-2.41-1.46-2.93s-1.6-1.79-2.75-3c-.33,3.31-1.14,11.34-1.49,12.18a4.51,4.51,0,0,1-1.69,1.73,9.35,9.35,0,0,0-1,.77c-.54.5-2,1.59-3.38,2.65-1,.78-2,1.55-2.6,2-1.29,1.06-6.12,5.74-6.17,5.79a.51.51,0,0,1-.64,0l-3.1-2.24a.5.5,0,0,1-.2-.34.48.48,0,0,1,.09-.37l7.44-9.77c.92-1.19,4.42-3.3,5.57-4-.38-1.71-2-9.25-3.26-15.7a18.58,18.58,0,0,1,1.61-12.38c0-.89-.22-5.62-.22-9.79,0-4.7.93-6.92,1-7a.39.39,0,0,1,.11-.17,7.17,7.17,0,0,1,2.31-1.51c1.06-.29,9,.83,10.67,1.4a5.18,5.18,0,0,1,3.52,5c0,2.19-2.58,9.05-2.94,10l.14,3.1.45,1.57c.11.31,2.95,8.37,3.57,10.53a86.85,86.85,0,0,1,1.41,9.52c0,.08.05.46.11,1,.22,1.83.66,5.64.66,7.9,0,1.88,0,4.28-.05,6,0,1,0,1.72,0,2.05,0,.74.67,6.25.92,8.31a.57.57,0,0,1,0,.26s-.24.56-.4.88-1.1.7-1.36.77A3.88,3.88,0,0,1,303.81,381Zm-10.62-31.89a.47.47,0,0,1,.35.15c.32.32,3.15,3.15,3.63,3.87s1.54,3.07,1.59,3.17a.41.41,0,0,1,0,.22,46.46,46.46,0,0,0,.31,6c.29,2.31,1.92,8.65,2.8,12.05.29,1.12.49,1.9.53,2.09a10,10,0,0,0,1.12,3.26,2.31,2.31,0,0,0,1.55-.34l.27-.64c-.13-1.05-.91-7.41-.91-8.3,0-.33,0-1.09,0-2.06,0-1.72.05-4.11.05-6,0-2.2-.44-6-.65-7.78-.07-.64-.12-1.05-.12-1.13a86.19,86.19,0,0,0-1.38-9.24c-.6-2.13-3.52-10.43-3.55-10.51l-.47-1.65a.5.5,0,0,1,0-.12l-.16-3.25a.76.76,0,0,1,0-.21c.81-2.11,2.92-8,2.92-9.73a4.14,4.14,0,0,0-2.85-4,52.47,52.47,0,0,0-10.08-1.39,6.09,6.09,0,0,0-1.8,1.2,20,20,0,0,0-.85,6.53c0,4.58.23,9.84.23,9.9a.46.46,0,0,1-.08.28,17.62,17.62,0,0,0-1.56,11.81c1.38,7.27,3.31,15.93,3.33,16a.5.5,0,0,1-.24.54c-1.29.74-4.81,2.89-5.58,3.9s-5.83,7.65-7.13,9.36l2.35,1.7c1.09-1.06,4.78-4.61,5.92-5.55.57-.47,1.59-1.24,2.64-2,1.37-1,2.79-2.12,3.31-2.59a9.16,9.16,0,0,1,1.07-.84,3.81,3.81,0,0,0,1.36-1.31c.26-.67,1.07-8.3,1.51-12.95a.5.5,0,0,1,.33-.42A.51.51,0,0,1,293.19,349.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.27,353.73a86,86,0,0,0-1.39-9.38c-.62-2.17-3.57-10.54-3.57-10.54l-.32-1.1c-1.75.31-4.42.73-7.58,1a10.66,10.66,0,0,1-6.71-1.32,18.91,18.91,0,0,0-1,11c1.4,7.36,3.33,16,3.33,16s-4.72,2.71-5.73,4c-.62.81-3.28,4.29-5.24,6.87a8.15,8.15,0,0,1,3.19,2.94c1.45-1.39,3.2-3,3.91-3.61,1.32-1.09,5-3.8,6-4.65s2.17-1.4,2.56-2.33,1.55-13.09,1.55-13.09,3.1,3.1,3.56,3.8,1.55,3.09,1.55,3.09a48.22,48.22,0,0,0,.31,6.13c.36,2.84,2.74,11.78,3.25,13.8a19.67,19.67,0,0,0,3.62-.84c-.25-2.08-.51-4.41-.51-4.91,0-.93.07-5.11.07-8.05S304.27,354,304.27,353.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.86,376.94a.5.5,0,0,1-.49-.38l-.43-1.71c-.89-3.42-2.53-9.79-2.82-12.15a47,47,0,0,1-.32-6.08c-.33-.73-1.12-2.41-1.46-2.93s-1.6-1.79-2.75-3c-.33,3.31-1.14,11.34-1.49,12.18a4.51,4.51,0,0,1-1.69,1.73,9.35,9.35,0,0,0-1,.77c-.54.5-2,1.59-3.38,2.65-1,.78-2,1.55-2.6,2s-1.91,1.71-3.89,3.6a.5.5,0,0,1-.4.13.51.51,0,0,1-.36-.22,7.65,7.65,0,0,0-3-2.76.5.5,0,0,1-.28-.34.49.49,0,0,1,.08-.42l5.24-6.88c.92-1.19,4.42-3.3,5.57-4-.38-1.71-2-9.25-3.26-15.7a19.35,19.35,0,0,1,1.08-11.29.47.47,0,0,1,.3-.27.48.48,0,0,1,.42.05,10.18,10.18,0,0,0,6.39,1.24c3.18-.3,5.86-.72,7.55-1a.51.51,0,0,1,.57.36l.31,1.11c.11.31,2.95,8.37,3.57,10.53a86.78,86.78,0,0,1,1.41,9.51c0,.1.05.47.11,1,.22,1.83.66,5.64.66,7.9,0,1.88,0,4.28-.05,6,0,1,0,1.72,0,2.05s.06,1.14.5,4.85a.5.5,0,0,1-.33.53,19.79,19.79,0,0,1-3.72.87Zm-8.67-27.82a.47.47,0,0,1,.35.15c.32.32,3.15,3.15,3.63,3.87s1.54,3.07,1.59,3.17a.41.41,0,0,1,0,.22,46.46,46.46,0,0,0,.31,6c.29,2.3,1.92,8.63,2.79,12,.13.51.25.94.33,1.28a17.84,17.84,0,0,0,2.7-.63c-.31-2.62-.46-4.15-.46-4.56s0-1.09,0-2.06c0-1.72.05-4.11.05-6,0-2.2-.44-6-.65-7.78-.07-.62-.12-1-.12-1.13a86.19,86.19,0,0,0-1.38-9.24c-.6-2.13-3.52-10.43-3.55-10.51l-.2-.7c-1.72.29-4.24.68-7.18,1a11.56,11.56,0,0,1-6.51-1.1,18.71,18.71,0,0,0-.8,10.19c1.38,7.27,3.31,15.93,3.33,16a.5.5,0,0,1-.24.54c-1.29.74-4.81,2.89-5.58,3.9l-4.88,6.4a8.64,8.64,0,0,1,2.5,2.35c1.32-1.25,2.86-2.7,3.52-3.24s1.59-1.24,2.64-2c1.37-1,2.79-2.12,3.31-2.59a9.16,9.16,0,0,1,1.07-.84,3.81,3.81,0,0,0,1.36-1.31c.26-.67,1.07-8.3,1.51-12.95a.5.5,0,0,1,.33-.42A.51.51,0,0,1,293.19,349.12Zm11.58,4.61h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.82,373.25s-2.59,2.42-2.59,2.87a22,22,0,0,0,2.15,4.52,11.46,11.46,0,0,0,3.48,3c1,.37,2.81.59,3-.37s-1.71-2.3-2-2.89a47,47,0,0,1-1-4.92S274.94,373.27,273.82,373.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.58,384.49a6.09,6.09,0,0,1-1.89-.34,12,12,0,0,1-3.72-3.22,20.71,20.71,0,0,1-2.24-4.81c0-.2,0-.66,2.75-3.24a.63.63,0,0,1,.35-.13c1.27,0,3.11,2,3.46,2.41a.53.53,0,0,1,.13.26,41.39,41.39,0,0,0,.92,4.77,4.52,4.52,0,0,0,.61.67c.73.73,1.64,1.65,1.43,2.56a1.24,1.24,0,0,1-.64.83A2.54,2.54,0,0,1,278.58,384.49Zm-6.84-8.32a24.45,24.45,0,0,0,2,4.17,11.25,11.25,0,0,0,3.25,2.87,3.54,3.54,0,0,0,2.23.16.24.24,0,0,0,.15-.18c.08-.37-.73-1.18-1.17-1.62a4.14,4.14,0,0,1-.79-.93,37.08,37.08,0,0,1-1-4.92,7.79,7.79,0,0,0-2.46-1.94A19.42,19.42,0,0,0,271.74,376.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.86,383.68c-1.93-1.34-2.3-3.78-3.56-6s-2.07-1.55-2.07-1.55a22,22,0,0,0,2.15,4.52A11.46,11.46,0,0,0,276.86,383.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.86,384.18a.47.47,0,0,1-.17,0,12,12,0,0,1-3.72-3.22,20.71,20.71,0,0,1-2.24-4.81.5.5,0,0,1,.18-.39,1,1,0,0,1,.87-.18c.66.12,1.32.75,2,1.88a23.93,23.93,0,0,1,1.06,2.25,7.47,7.47,0,0,0,2.34,3.59.49.49,0,0,1,.16.64A.5.5,0,0,1,276.86,384.18Zm-4.93-7.47a26.45,26.45,0,0,0,1.85,3.63c.11.15.26.34.44.54-.12-.27-.23-.54-.34-.81-.31-.71-.62-1.45-1-2.15A3.94,3.94,0,0,0,271.93,376.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.68 315.92 287.77 323.59 290.01 324.29 288.7 316.31 286.68 315.92",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,324.79a.32.32,0,0,1-.14,0l-2.25-.69a.51.51,0,0,1-.35-.41L286.19,316a.49.49,0,0,1,.15-.43.48.48,0,0,1,.44-.13l2,.38a.5.5,0,0,1,.4.41l1.32,8a.49.49,0,0,1-.17.46A.51.51,0,0,1,290,324.79Zm-1.79-1.59,1.17.37-1.13-6.84-1-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,325.06s-7.28-2-8.67-2.25-2.48-.07-2.48.86-4.42,13.71-4.42,14.48,6.9,3.8,10.46,4.88a4.6,4.6,0,0,0,5.27-1.39s2.63-15.57,2.25-15.88A10.94,10.94,0,0,0,296.75,325.06Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.37,343.81a6.31,6.31,0,0,1-1.87-.3c-.92-.28-10.82-3.79-10.82-5.36a64.16,64.16,0,0,1,2.08-6.87c1-3,2.31-7.12,2.34-7.62a1.32,1.32,0,0,1,.45-1,3.2,3.2,0,0,1,2.61-.32c1.38.23,8.21,2.11,8.71,2.25a9,9,0,0,1,2.6.8c.27.22.62.49-2.07,16.35a.5.5,0,0,1-.08.2A4.94,4.94,0,0,1,293.37,343.81Zm-11.67-5.74c.72.77,6.34,3.35,10.09,4.49a4.17,4.17,0,0,0,4.65-1.12c.9-5.36,2.25-13.88,2.26-15.37a15.49,15.49,0,0,0-2-.52h0c-.07,0-7.27-2-8.62-2.23s-1.71,0-1.8.09a.33.33,0,0,0-.1.27,72.57,72.57,0,0,1-2.38,7.91C282.88,334.17,281.84,337.36,281.7,338.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.91,341.64s.41-2.44.89-5.41l-14.5-5c-1.07,3.32-2.12,6.54-2.12,6.91,0,.78,6.9,3.8,10.46,4.88A4.6,4.6,0,0,0,296.91,341.64Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.37,343.81a6.31,6.31,0,0,1-1.87-.3c-.92-.28-10.82-3.79-10.82-5.36a66.73,66.73,0,0,1,2.09-6.9l.06-.16a.48.48,0,0,1,.25-.29.43.43,0,0,1,.38,0l14.5,5a.49.49,0,0,1,.33.55c-.47,3-.89,5.41-.89,5.41a.5.5,0,0,1-.08.2A4.94,4.94,0,0,1,293.37,343.81Zm-11.67-5.74c.73.77,6.34,3.35,10.09,4.49a4.17,4.17,0,0,0,4.65-1.12c.08-.5.41-2.48.8-4.88l-13.62-4.68C282.8,334.42,281.84,337.39,281.7,338.07Zm15.21,3.57h0ZM281.65,338Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.53,319.56s-2.09,6.58-2.79,9.53-.15,17.51-.15,18.05a17.89,17.89,0,0,0,.77,2.4c.16.62-.23,1.09,0,1.47s1.63.31,2.09.16a1.43,1.43,0,0,0,.85-1.4c0-.69-1.39-2.63-1.7-3.25s-.39.08-.39-.93,2.25-9.3,2.4-11,.78-5,.78-5,3.1-6.74,3.41-8.91.08-3.64-1.55-4.41-3.49,1.31-3.49,1.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,351.8a1.69,1.69,0,0,1-1.46-.53,1.37,1.37,0,0,1-.09-1,1.32,1.32,0,0,0,0-.59c-.06-.22-.19-.54-.32-.87a5.62,5.62,0,0,1-.47-1.65c0-.07,0-.35,0-.8-.28-9.77-.22-15.62.19-17.37.7-2.93,2.78-9.5,2.8-9.56a.51.51,0,0,1,.63-.33.51.51,0,0,1,.33.63c0,.07-2.1,6.6-2.78,9.49-.27,1.15-.52,5.05-.17,17.11,0,.47,0,.76,0,.83a5.57,5.57,0,0,0,.41,1.29c.14.37.28.72.35,1a2.32,2.32,0,0,1,0,1,.77.77,0,0,0,0,.31,3.76,3.76,0,0,0,1.5-.07.94.94,0,0,0,.51-.92,9.21,9.21,0,0,0-1.13-2.15c-.23-.37-.42-.68-.52-.88l-.06-.1c-.38-.1-.38-.5-.38-1.05a45.32,45.32,0,0,1,1.14-5.26c.56-2.33,1.19-5,1.27-5.79.15-1.7.75-4.94.78-5.08a.53.53,0,0,1,0-.12c0-.06,3.08-6.69,3.37-8.77.32-2.24,0-3.3-1.27-3.89s-2.88,1.18-2.89,1.2a.51.51,0,0,1-.71,0,.5.5,0,0,1,0-.71c.08-.09,2.13-2.36,4.07-1.43,2.09,1,2.1,3.05,1.83,4.93-.3,2.14-3.1,8.29-3.42,9-.08.45-.62,3.39-.76,4.92-.08.9-.7,3.46-1.29,5.93-.52,2.15-1.11,4.59-1.11,5v.27a1.22,1.22,0,0,1,.34.44,9.16,9.16,0,0,0,.47.79,6.91,6.91,0,0,1,1.28,2.68,1.92,1.92,0,0,1-1.19,1.87A4.49,4.49,0,0,1,296.39,351.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.25,325.21c-.79-.64-3.38-.9-5.15-1-.53,1.77-1.07,3.65-1.36,4.89-.7,2.94-.15,17.51-.15,18.05a17.89,17.89,0,0,0,.77,2.4c.16.62-.23,1.09,0,1.47s1.63.31,2.09.16a1.43,1.43,0,0,0,.85-1.4c0-.69-1.39-2.63-1.7-3.25s-.39.08-.39-.93,2.25-9.3,2.4-11,.78-5,.78-5,1-2.09,1.87-4.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,351.8a1.69,1.69,0,0,1-1.46-.53,1.37,1.37,0,0,1-.09-1,1.32,1.32,0,0,0,0-.59c-.06-.22-.19-.54-.32-.87a5.62,5.62,0,0,1-.47-1.65c0-.07,0-.35,0-.8-.28-9.77-.22-15.62.19-17.37.26-1.07.72-2.72,1.37-4.91a.5.5,0,0,1,.51-.36c2.9.18,4.73.56,5.43,1.13h0l0,0a.5.5,0,0,1,.13.56c-.81,2-1.69,3.94-1.85,4.3s-.62,3.39-.76,4.92c-.08.9-.7,3.46-1.29,5.93-.52,2.15-1.11,4.59-1.11,5v.27a1.22,1.22,0,0,1,.34.44,9.16,9.16,0,0,0,.47.79,6.91,6.91,0,0,1,1.28,2.68,1.92,1.92,0,0,1-1.19,1.87A4.49,4.49,0,0,1,296.39,351.8Zm.08-27.07c-.59,2-1,3.48-1.24,4.47-.27,1.15-.52,5.05-.17,17.11,0,.47,0,.76,0,.83a5.57,5.57,0,0,0,.41,1.29c.14.37.28.72.35,1a2.32,2.32,0,0,1,0,1,.77.77,0,0,0,0,.31,3.76,3.76,0,0,0,1.5-.07.94.94,0,0,0,.51-.92,9.21,9.21,0,0,0-1.13-2.15c-.23-.37-.42-.68-.52-.88l-.06-.1c-.38-.1-.38-.5-.38-1.05a45.32,45.32,0,0,1,1.14-5.26c.56-2.33,1.19-5,1.27-5.79.15-1.7.75-4.94.78-5.08a.53.53,0,0,1,0-.12s.86-1.86,1.71-3.91A15.1,15.1,0,0,0,296.47,324.73Zm4.45.87h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,293.78a6.67,6.67,0,0,0-6.4-1.35c-3.57,1.28-4.91,4-4.91,6.06a22.84,22.84,0,0,1-.47,4.18s-4.65,3-5.46,6.87a10.92,10.92,0,0,0,1.55,8.49,6.21,6.21,0,0,0,4.78,2.62,9.87,9.87,0,0,0,2.76-.67s-1.21-.94-1.41-1.55-.34-.94-.34-.94,2.7,1.35,4.58,1.08,5.66-.74,6.74-3.37,1.34-4.18.6-5.86-1.68-1.69-1.68-4.18,2.49-2.29,2.42-6.67S304.05,293.17,302.5,293.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.47,321.16a6.8,6.8,0,0,1-5.08-2.86,11.4,11.4,0,0,1-1.62-8.86c.76-3.67,4.6-6.46,5.5-7.07a22.23,22.23,0,0,0,.42-3.88c0-2.14,1.37-5.14,5.25-6.53a7,7,0,0,1,6.67,1.25,2,2,0,0,1,1.68.2c1,.65,1.43,2.26,1.47,5.08a6.29,6.29,0,0,1-1.56,4.7,2.84,2.84,0,0,0-.86,2,3.55,3.55,0,0,0,.8,2.58,6.35,6.35,0,0,1,.84,1.4c.85,1.94.45,3.69-.6,6.25-1.16,2.82-4.95,3.36-7,3.65l-.15,0a8.36,8.36,0,0,1-3.77-.65,6.53,6.53,0,0,0,1.18,1.18.51.51,0,0,1,.19.46.48.48,0,0,1-.31.39,10.26,10.26,0,0,1-2.92.71Zm6.65-28.58a5.5,5.5,0,0,0-1.85.32c-3.38,1.22-4.58,3.77-4.58,5.59a22.78,22.78,0,0,1-.49,4.29.44.44,0,0,1-.22.31s-4.48,2.9-5.23,6.55a10.46,10.46,0,0,0,1.48,8.11,5.82,5.82,0,0,0,4.33,2.41,8.17,8.17,0,0,0,1.81-.37,3.57,3.57,0,0,1-.91-1.2c-.19-.58-.32-.91-.32-.92a.49.49,0,0,1,.12-.55.5.5,0,0,1,.56-.08s2.59,1.28,4.29,1l.15,0c1.83-.26,5.25-.75,6.19-3,1.11-2.69,1.25-4,.62-5.47a6.75,6.75,0,0,0-.73-1.21,4.42,4.42,0,0,1-1-3.17,3.84,3.84,0,0,1,1.08-2.6,5.32,5.32,0,0,0,1.34-4.06c0-3-.58-4-1-4.26-.1-.06-.38-.25-1.05,0a.52.52,0,0,1-.52-.1A6.42,6.42,0,0,0,298.12,292.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.61,394.79s20.8,31.46,22.1,32.94a8.75,8.75,0,0,1-2.23,5.59c-2.23,2.23-4.65,4.65-4.1,5.21s4.44-.57,6.15-.74c3.53-.38,6.7-3.73,6.7-3.73s3.53-5.21,3.72-8-4.47-3.72-4.47-3.72l-1.3-.56-12.61-30.52Z",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.06,439.18a1.38,1.38,0,0,1-1-.3c-.83-.83.54-2.36,4.1-5.92a8.18,8.18,0,0,0,2.08-5.06c-2.16-2.8-21.19-31.58-22-32.83a.5.5,0,0,1,0-.46.47.47,0,0,1,.34-.3l14-3.54a.49.49,0,0,1,.58.3l12.53,30.33,1.07.46c.57.12,5,1.18,4.82,4.23s-3.66,8-3.81,8.25-3.38,3.56-7.06,3.94c-.55.06-1.34.22-2.18.39A19.49,19.49,0,0,1,228.06,439.18Zm-.23-1a19.18,19.18,0,0,0,3.37-.51c.87-.17,1.68-.34,2.27-.4,3.31-.35,6.36-3.54,6.39-3.57h0s3.42-5.07,3.59-7.69c.16-2.32-4-3.19-4.07-3.2l-.1,0-1.3-.56a.49.49,0,0,1-.26-.27l-12.44-30.12-12.86,3.25c7.28,11,20.67,31.17,21.67,32.31a.47.47,0,0,1,.12.32,9.1,9.1,0,0,1-2.38,5.94C230.41,435.09,228.08,437.42,227.83,438.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.48,422.34l-.36-.16a9.61,9.61,0,0,1-.57,2.58c-.93,2.42-1.67,3-1.67,3h-3.17a8.75,8.75,0,0,1-2.23,5.59c-2.23,2.23-4.65,4.65-4.1,5.21s4.44-.57,6.15-.74c3.53-.38,6.7-3.73,6.7-3.73s3.53-5.21,3.72-8S239.48,422.34,239.48,422.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.06,439.18a1.38,1.38,0,0,1-1-.3c-.83-.83.54-2.36,4.1-5.92a8.25,8.25,0,0,0,2.08-5.23.51.51,0,0,1,.5-.5h3a8.67,8.67,0,0,0,1.41-2.65,9.12,9.12,0,0,0,.55-2.44.49.49,0,0,1,.24-.39.51.51,0,0,1,.45,0l.31.14c.58.12,5,1.18,4.82,4.23s-3.66,8-3.81,8.25-3.38,3.56-7.06,3.94c-.55.06-1.34.22-2.18.39A19.49,19.49,0,0,1,228.06,439.18Zm-.23-1a19.18,19.18,0,0,0,3.37-.51c.87-.17,1.68-.34,2.27-.4,3.31-.35,6.36-3.54,6.39-3.57h0s3.42-5.07,3.59-7.69c.14-2-3.14-3-3.91-3.16a9.8,9.8,0,0,1-.52,2.07c-1,2.48-1.76,3.13-1.84,3.19a.49.49,0,0,1-.3.1h-2.69a9,9,0,0,1-2.36,5.44C230.41,435.09,228.08,437.42,227.83,438.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.86,391.26l11,38.34-6.33,3.53s-6.51,2.8-6.14,3.91,3.35.93,6.89.93,11.72-.74,12.47-.93,1.12-1.11,1.12-2.42-.75-6.51-.75-7.26S208.63,390,208.63,390Z",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,438.48c-2.68,0-4.42-.13-4.8-1.28s1.81-2.55,6.42-4.53l5.93-3.32-10.87-38a.5.5,0,0,1,.43-.63l13.78-1.31a.51.51,0,0,1,.54.44c.46,3.76,4.47,36.72,4.47,37.47,0,.29.15,1.53.29,2.72.22,1.77.46,3.77.46,4.54,0,2.2-.94,2.77-1.5,2.91-.88.22-9.14.94-12.59.94H197.7Zm-2.19-46.78,10.81,37.76a.49.49,0,0,1-.23.57l-6.33,3.54c-3.07,1.32-5.75,2.86-5.91,3.4.21.54,2.9.53,5.07.51h1.34c3.66,0,11.73-.76,12.35-.91.45-.12.74-.86.74-1.94,0-.71-.25-2.77-.45-4.42s-.3-2.5-.3-2.84c0-.78-2.86-24.17-4.4-36.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.85,434.62c0-.58-.15-1.94-.32-3.34l-5.64.92-2-2.6-6.33,3.53s-6.51,2.8-6.14,3.91,3.35.93,6.89.93,11.72-.74,12.47-.93S213.85,435.93,213.85,434.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,438.48c-2.68,0-4.42-.13-4.8-1.28s1.81-2.55,6.42-4.53l6.28-3.51a.5.5,0,0,1,.64.13l1.86,2.37,5.35-.87a.5.5,0,0,1,.38.09.55.55,0,0,1,.2.35c.16,1.32.32,2.77.32,3.39,0,2.2-.94,2.77-1.5,2.91-.88.22-9.14.94-12.59.94H197.7Zm8-8.24-6,3.33c-3.07,1.32-5.75,2.86-5.91,3.4.21.54,2.9.53,5.07.51h1.34c3.66,0,11.73-.76,12.35-.91.45-.12.74-.86.74-1.94,0-.5-.13-1.66-.25-2.76l-5.13.84a.48.48,0,0,1-.47-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,303.39s-6.74,2.76-7.62,5-2.49,14.76-2.49,14.76-6.58,10.68-5,15.21,7.17,5.26,8.63,4.82a21,21,0,0,0,4.38-2.77s4.83-34.8,5-35.39S198.11,303.12,197.22,303.39Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.81,343.75c-2.32,0-6.68-1.16-8.14-5.26-1.61-4.53,4.27-14.41,5-15.55.17-1.3,1.65-12.64,2.5-14.78.93-2.32,7.19-4.94,7.9-5.23h0c.88-.28,2.39.46,3.08,1.12a1.14,1.14,0,0,1,.46,1.07c-.14.67-3.31,23.4-5,35.32a.52.52,0,0,1-.18.33c-.13.09-3,2.4-4.56,2.86A3.93,3.93,0,0,1,189.81,343.75Zm7.57-39.88c-1.84.75-6.67,3-7.32,4.66-.84,2.11-2.44,14.52-2.45,14.65a.48.48,0,0,1-.07.2c-.07.1-6.44,10.52-4.93,14.77s6.82,4.87,8,4.52a18.92,18.92,0,0,0,4.07-2.57c.59-4.29,4.62-33.34,4.93-35.16A3.34,3.34,0,0,0,197.38,303.87Zm-10.27,19.24h0Zm12.53-18.25v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.69,339.34s1.76,7.6,1.47,11.11-4.83,10.09-9.8,11.55A21.64,21.64,0,0,1,225,362l1.17-8.62,1.9-21.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.44,363.16a23.53,23.53,0,0,1-5.59-.67.51.51,0,0,1-.37-.55l1.17-8.63,1.9-21.47a.52.52,0,0,1,.25-.39.5.5,0,0,1,.46,0l15.65,7.46a.49.49,0,0,1,.27.34c.07.31,1.77,7.72,1.47,11.27s-5,10.46-10.15,12A17.92,17.92,0,0,1,230.44,363.16Zm-4.9-1.54a20.89,20.89,0,0,0,9.68-.1c4.73-1.39,9.16-7.81,9.44-11.11.25-3.05-1.11-9.42-1.4-10.72l-14.78-7-1.83,20.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.37,350.87a157,157,0,0,0-1.49,20.66,173.84,173.84,0,0,0,.93,21.59s6.15,1.67,8.38,2a46.18,46.18,0,0,0,7.44,0L210.5,397,228,393.86s1.3-2.6.37-4.28-2-3.72-2-3.72l5.77-32.2S207.33,355.33,193.37,350.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5,397.53a.53.53,0,0,1-.36-.15l-1.7-1.7a44.7,44.7,0,0,1-7.33,0c-2.24-.37-8.18-2-8.43-2.06a.49.49,0,0,1-.36-.42,175.07,175.07,0,0,1-.94-21.66,159.73,159.73,0,0,1,1.5-20.73.5.5,0,0,1,.23-.35.54.54,0,0,1,.41-.05c13.71,4.39,38.29,2.78,38.53,2.77a.51.51,0,0,1,.41.16.51.51,0,0,1,.12.43l-5.74,32c.28.51,1.18,2.17,2,3.57,1,1.88-.3,4.63-.36,4.74a.46.46,0,0,1-.36.27l-17.5,3.17Zm-1.87-2.87a.53.53,0,0,1,.36.15l1.67,1.68,17-3.07c.27-.63.93-2.43.29-3.6-.93-1.67-2.05-3.72-2.05-3.72a.48.48,0,0,1-.06-.33l5.66-31.57c-3.92.21-25,1.16-37.7-2.68a166.26,166.26,0,0,0-1.4,20,179.5,179.5,0,0,0,.89,21.19c1.3.35,6.11,1.64,8,1.95a47.53,47.53,0,0,0,7.33,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,393.24a.5.5,0,0,1-.28-.91l1.84-1.23-1.32-2.22a.49.49,0,0,1,.17-.69.5.5,0,0,1,.68.17L226,391a.5.5,0,0,1-.15.67l-2.23,1.49A.5.5,0,0,1,223.34,393.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "227.62 362.41 221.48 384.37 223.09 387.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09,387.59a.51.51,0,0,1-.43-.25l-1.61-2.72a.48.48,0,0,1-.05-.39l6.14-22a.5.5,0,0,1,.61-.35.51.51,0,0,1,.35.62L222,384.3l1.5,2.53a.5.5,0,0,1-.17.69A.59.59,0,0,1,223.09,387.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.89,
    y1: 367.61,
    x2: 202.12,
    y2: 365.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.89,368.11a.5.5,0,0,1-.48-.34l-.76-2.22a.51.51,0,0,1,.31-.64.5.5,0,0,1,.63.31l.77,2.23a.5.5,0,0,1-.31.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.63,395.66a.5.5,0,0,1-.43-.25l-2-3.73a.46.46,0,0,1-.06-.23l-.37-14.06-2.46-7.17a.49.49,0,0,1,.31-.63.5.5,0,0,1,.63.31l2.49,7.23a.77.77,0,0,1,0,.15l.37,14,2,3.61a.49.49,0,0,1-.19.68A.54.54,0,0,1,208.63,395.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.18,296.75s-11.23,4.72-12,6.64-4.14,25.41-4.14,33.83-1.77,14.92-.59,16.25,16.1,5.46,25.7,4.87,14.48-2.07,14.77-3.25.74-5,.74-5,4.43-31.76,3.55-38.7-2.22-9-3.7-9.9-13.73-5.46-16.1-5.61A55,55,0,0,0,209.18,296.75Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.24,358.9c-9.57,0-22.85-3.67-24.12-5.1-.8-.89-.57-3.09-.18-6.72a93,93,0,0,0,.64-9.86c0-8.57,3.44-32.11,4.17-34s10.33-6.12,12.24-6.93l.1,0c.25,0,6-1.05,8.39-.89s14.9,4.82,16.33,5.68,3,2.74,3.93,10.27c.89,6.92-3.36,37.53-3.54,38.83,0,.15-.45,3.87-.75,5.07-.5,2-8.2,3.2-15.23,3.63Q217.26,358.9,216.24,358.9Zm-6.92-61.67c-4.58,1.93-11.18,5.16-11.64,6.34-.71,1.86-4.1,25.15-4.1,33.65a92,92,0,0,1-.65,10c-.31,2.89-.57,5.38-.07,5.95.9,1,15.54,5.31,25.3,4.7,10.34-.63,14.16-2.23,14.32-2.87.28-1.14.72-4.92.73-5,0-.32,4.41-31.78,3.54-38.58-.91-7.12-2.25-8.81-3.45-9.53-1.36-.81-13.55-5.4-15.88-5.54A52.46,52.46,0,0,0,209.32,297.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.63,300.25s-4.28,11.83-5.16,16.11a52.1,52.1,0,0,0-1,7.89l-3.29.33,5-21.19S199.76,300.14,201.63,300.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.2,325.08a.52.52,0,0,1-.38-.17.51.51,0,0,1-.11-.44l5-21.19a.72.72,0,0,1,.09-.2c.28-.35,2.78-3.44,4.83-3.33a.49.49,0,0,1,.39.22.51.51,0,0,1,.06.45c0,.11-4.28,11.85-5.14,16a52.05,52.05,0,0,0-1,7.81.5.5,0,0,1-.45.48l-3.29.33Zm5.48-21.46L192.85,324l2.16-.21a53.62,53.62,0,0,1,1-7.54c.75-3.66,3.89-12.59,4.88-15.36A9.91,9.91,0,0,0,197.68,303.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.55,301.47a63.88,63.88,0,0,0-6.4-2.6c-1.4,1.64-3.73,5.1-5.09,11.23-2.05,9.21-.3,12.87.43,17.11s1.9,9.65,4.54,13.45a42.06,42.06,0,0,0,7,7c.3-2.25.78-5.89,1.28-10.06-3.93-4.5-9.79-11.39-10.47-13.22-1-2.78,1.61-13.89,3.22-16.67A34.78,34.78,0,0,1,233.55,301.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,348.21a.56.56,0,0,1-.32-.11,42.13,42.13,0,0,1-7.09-7.16c-2.66-3.85-3.86-9.32-4.61-13.65-.13-.78-.3-1.54-.48-2.32-.77-3.46-1.64-7.37,0-15,1.4-6.32,3.86-9.89,5.21-11.45a.48.48,0,0,1,.55-.14,69.52,69.52,0,0,1,6.48,2.64.5.5,0,0,1,.24.38.47.47,0,0,1-.16.42,34.86,34.86,0,0,0-5.41,6.17c-1.58,2.73-4.11,13.71-3.18,16.25.48,1.3,4.27,6.06,10.38,13.06a.5.5,0,0,1,.12.39c-.5,4.15-1,7.76-1.28,10.07a.53.53,0,0,1-.31.4A.63.63,0,0,1,234,348.21Zm-6.71-48.75a25.74,25.74,0,0,0-4.77,10.75c-1.64,7.39-.79,11.19,0,14.54.18.8.35,1.57.49,2.37.73,4.23,1.89,9.56,4.45,13.25a38.7,38.7,0,0,0,6.21,6.37c.3-2.24.7-5.38,1.13-8.93-4.42-5.06-9.75-11.39-10.42-13.21-1.11-3,1.69-14.39,3.26-17.09a31.31,31.31,0,0,1,5.07-5.91C231.65,301.12,229.62,300.31,227.31,299.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.91,340.51a38.08,38.08,0,0,0-.52,6.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.39,347.32a.49.49,0,0,1-.5-.47,38.65,38.65,0,0,1,.52-6.41A.51.51,0,0,1,203,340a.5.5,0,0,1,.42.57,37.47,37.47,0,0,0-.51,6.21.51.51,0,0,1-.48.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.52,320.38s-2,9.65-3.23,17.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.29,338.41h-.08a.5.5,0,0,1-.41-.57C204,330,206,320.38,206,320.28a.5.5,0,0,1,.59-.39.49.49,0,0,1,.39.59c0,.1-2,9.73-3.23,17.51A.49.49,0,0,1,203.29,338.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.34,300.59s-5.47,6.2-6.65,12.26,1.77,9.15,1.77,9.15l4,6.95s1.33,9.16,7.68,11.52,10.2-2.36,9.61-6.06-3.85-9.16-3.85-9.16-1.77-11.67-3.69-16.84S234.34,301.62,231.34,300.59Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.42,341.61a10,10,0,0,1-3.46-.67c-6.27-2.34-7.82-10.77-8-11.82l-3.91-6.82c-.39-.44-3-3.65-1.86-9.55,1.19-6.12,6.54-12.24,6.76-12.49a.51.51,0,0,1,.54-.15c2.47.85,7.06,2.44,9.17,8.13,1.85,5,3.52,15.64,3.7,16.84.43.74,3.29,5.72,3.86,9.25a6.32,6.32,0,0,1-2.32,5.73A7,7,0,0,1,241.42,341.61Zm-9.92-40.44c-1,1.22-5.31,6.6-6.32,11.77-1.12,5.74,1.62,8.69,1.65,8.72a.86.86,0,0,1,.07.1l4,6.94a.48.48,0,0,1,.06.18c0,.08,1.36,8.89,7.36,11.12,3.64,1.36,5.92.13,7-.71a5.32,5.32,0,0,0,2-4.8c-.57-3.56-3.74-8.93-3.78-9a.55.55,0,0,1-.06-.18c0-.12-1.79-11.68-3.67-16.74C238,303.91,234.61,302.27,231.5,301.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.09,328.8s-11.52-2.22-12-.89-4.2,3.33-3.61,5,6.12,6.86,10.56,8.78,10.63.44,11.67-3.25a9.59,9.59,0,0,0-1.48-8.12",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.33,343a11.27,11.27,0,0,1-4.46-.88c-4.44-1.92-10.15-7.21-10.83-9.07-.47-1.3.92-2.56,2.14-3.67a6.33,6.33,0,0,0,1.47-1.62c.38-1.15,4.6-1,12.53.56a.5.5,0,1,1-.19,1c-4.9-.94-10.6-1.64-11.42-1.15a6.39,6.39,0,0,1-1.72,2c-.94.86-2.11,1.92-1.87,2.59.49,1.34,5.8,6.55,10.28,8.49a10.62,10.62,0,0,0,8.3-.09,4.77,4.77,0,0,0,2.69-2.83,9.1,9.1,0,0,0-1.4-7.71.5.5,0,0,1,.82-.57,10.07,10.07,0,0,1,1.55,8.55A5.65,5.65,0,0,1,245,342,10.94,10.94,0,0,1,240.33,343Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,330.28s-3.39-4.29-3.69-4.73.44-2.95-.89-3.55a24.33,24.33,0,0,0-5.9-1.32c-1.63-.15-2.66.59-2.66,1.62a1.2,1.2,0,0,0,1,1.18,9.6,9.6,0,0,0-.15,4.58c.59,2.07,1.18,2.36,2.07,2.51s3.55.89,3.55.89,2.19,2.4,3.37,2.25S230,333.53,231,330.28Z",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.67,334.22c-1.27,0-3-1.74-3.54-2.32-.56-.15-2.62-.71-3.36-.83-1.15-.19-1.85-.69-2.47-2.87a9.61,9.61,0,0,1,0-4.39,1.61,1.61,0,0,1-.93-1.51,1.91,1.91,0,0,1,.64-1.44,3.28,3.28,0,0,1,2.56-.68,25.09,25.09,0,0,1,6.07,1.37c1.2.53,1.15,2.06,1.11,3.07a3.79,3.79,0,0,0,0,.7c.19.26,2.28,2.93,3.65,4.65a.5.5,0,0,1,.08.46c-1,3.21-2.13,3.59-3.59,3.77h-.26Zm-7.52-13.06a2.14,2.14,0,0,0-1.44.44.91.91,0,0,0-.31.7.69.69,0,0,0,.6.69.49.49,0,0,1,.41.63,9.13,9.13,0,0,0-.15,4.3c.57,2,1.06,2.06,1.67,2.16.91.15,3.49.87,3.6.9a.49.49,0,0,1,.24.14c.81.89,2.31,2.16,2.94,2.1h.1c1-.13,1.8-.23,2.67-2.83-.73-.93-3.28-4.15-3.55-4.55a2.23,2.23,0,0,1-.15-1.25c0-.78.07-1.86-.52-2.12a24.32,24.32,0,0,0-5.75-1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.89,322.53s.29,6.58.59,7.75a2.61,2.61,0,0,0,1.46,1.9c.44.14,4.68-.44,5.11-.88s.15-8.77-.43-9.5S191.35,321.51,189.89,322.53Z",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,332.69a1.35,1.35,0,0,1-.41,0A3,3,0,0,1,190,330.4c-.3-1.21-.59-7.58-.6-7.85a.49.49,0,0,1,.21-.43c1.43-1,6.5-1.76,7.41-.63.54.67,1.18,9.39.4,10.16C196.89,332.17,193.46,332.69,192.19,332.69Zm-1.79-9.89c.1,2,.34,6.48.56,7.36a2.12,2.12,0,0,0,1.14,1.54,19.31,19.31,0,0,0,4.56-.74c.3-1.15,0-8.17-.45-8.87C195.71,321.7,191.92,322,190.4,322.8Zm6.23,8.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.9,326.77s-1.87.11-5.37,4.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.53,331.44a.5.5,0,0,1-.33-.12.51.51,0,0,1,0-.71c3.54-4.1,5.5-4.32,5.72-4.34a.52.52,0,0,1,.53.47.5.5,0,0,1-.46.53c-.06,0-1.82.27-5,4A.5.5,0,0,1,184.53,331.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,328.42s-1.76,3.83-.33,6.25,7.37-3.37,7.37-3.37-4,1.57-5.11.88S190,329.18,190,328.42Z",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.75,335.75h-.27a1.67,1.67,0,0,1-1.23-.82c-1.54-2.61.23-6.54.3-6.71a.5.5,0,0,1,1,.21,5.34,5.34,0,0,0,1.68,3.33c.65.38,3.18-.32,4.68-.91a.49.49,0,0,1,.6.19.5.5,0,0,1-.07.63C197,332.09,193.11,335.75,190.75,335.75Zm-.82-5.58a5.82,5.82,0,0,0,.18,4.24.66.66,0,0,0,.5.34c1,.12,2.74-1,4.28-2.22-1.2.31-2.52.49-3.21.08A4.92,4.92,0,0,1,189.93,330.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.49,292.31l1.92,9.61s-.89,14.47-.74,16.83,2.07,0,2.66-.73S217.75,299,217.75,299l1.48-3.54s-6.5.59-8.13,0-6-4.58-6-4.58Z",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24,320.28a1,1,0,0,1-.28,0c-.47-.15-.74-.64-.79-1.45-.14-2.31.66-15.65.74-16.84L205,292.43l-.43-1.45a.48.48,0,0,1,.21-.56.5.5,0,0,1,.6,0c1.21,1.1,4.63,4,5.89,4.49s6.13.13,7.91,0a.5.5,0,0,1,.51.69l-1.48,3.54c-1.31,3.08-7.89,18.42-8.49,19.18C208.94,319.31,208,320.28,207.24,320.28ZM206,292.34l1.9,9.48a.53.53,0,0,1,0,.13c0,.14-.88,14.47-.74,16.77,0,.47.13.58.13.58s.41-.06,1.64-1.6c.47-.66,5.25-11.69,8.35-18.94l1.16-2.78c-1.87.15-6.14.41-7.52-.09A24.75,24.75,0,0,1,206,292.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.39,302.27c-.14,2.25-.85,14.34-.72,16.48.15,2.37,2.07,0,2.66-.73.42-.53,4.58-10.12,6.89-15.49A8.34,8.34,0,0,1,207.39,302.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24,320.28a1,1,0,0,1-.28,0c-.47-.15-.74-.64-.79-1.45-.13-2.18.57-14.17.72-16.55a.48.48,0,0,1,.27-.41.5.5,0,0,1,.5,0,7.89,7.89,0,0,0,8.33.23.49.49,0,0,1,.57.08.51.51,0,0,1,.12.56c-6.43,14.94-6.83,15.44-7,15.6C208.94,319.31,208,320.28,207.24,320.28Zm.6-17.16c-.19,3.24-.79,13.67-.67,15.6,0,.47.13.58.13.58s.41-.06,1.64-1.6c.31-.43,2.65-5.71,6.31-14.18A8.67,8.67,0,0,1,207.84,303.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.52,271.93s-4.28,1.18-5,3.4,2.36,10.48,2.36,10.48-3-.59-3,2.22a7.34,7.34,0,0,0,.18,1.61,3.56,3.56,0,0,0,3.84,2.73l.56-.06a18.64,18.64,0,0,0,4.87,4.44c2.81,1.62,9.6.88,11.23-3.4a13.16,13.16,0,0,0,.44-8.57c-.29-.89-1.18-8.57-2.66-11.82S208.89,271.19,206.52,271.93Z",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,298a7.91,7.91,0,0,1-3.85-.86,18.89,18.89,0,0,1-4.85-4.34l-.28,0a4.07,4.07,0,0,1-4.38-3.12,7.62,7.62,0,0,1-.19-1.72,2.64,2.64,0,0,1,.89-2.16,3,3,0,0,1,1.83-.61c-.78-2.16-2.77-8.1-2.1-10.09.8-2.41,5.07-3.64,5.35-3.72,1.51-.47,11.67-2.61,13.45,1.31,1.08,2.38,1.84,7,2.3,9.79.16,1,.31,1.86.38,2.07a13.58,13.58,0,0,1-.45,8.91,6.92,6.92,0,0,1-4.35,3.88A11.4,11.4,0,0,1,214,298Zm-8.47-6.23a.49.49,0,0,1,.4.21,18.24,18.24,0,0,0,4.72,4.29c1.56.9,4.47,1,6.77.15a5.93,5.93,0,0,0,3.74-3.29,12.73,12.73,0,0,0,.44-8.23c-.09-.28-.21-1-.42-2.23-.44-2.72-1.19-7.28-2.22-9.54-1.26-2.77-9.82-1.52-12.25-.76h0c-1.12.31-4.15,1.47-4.69,3.07s1.52,7.9,2.36,10.16a.48.48,0,0,1-.09.5.47.47,0,0,1-.47.16,2.62,2.62,0,0,0-1.84.34,1.71,1.71,0,0,0-.52,1.39,6.83,6.83,0,0,0,.17,1.5,3.07,3.07,0,0,0,3.3,2.34l.56-.05Zm1-19.88h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.37,273c-1.47-3.25-10.48-1.77-12.85-1,0,0-4.28,1.18-5,3.4s2.36,10.48,2.36,10.48,2.07,0,1.78-1-.74-3.25-.74-3.25,2.66-.15,2.36-1-1.33-5.17-1.33-5.17,7.68-3.55,12.11-2.22a14.52,14.52,0,0,0,1.55.38C219.52,273.31,219.45,273.13,219.37,273Z",
    style: {
      fill: "#5c5c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.86,286.31a.47.47,0,0,1-.46-.32c-.33-.86-3.15-8.5-2.37-10.82s5.17-3.67,5.36-3.72c1.46-.46,11.65-2.62,13.44,1.31.08.17.15.36.23.55a.51.51,0,0,1-.09.5.48.48,0,0,1-.48.17,14.74,14.74,0,0,1-1.59-.39c-3.66-1.1-9.81,1.35-11.38,2,.26,1.08,1,4,1.21,4.72a.86.86,0,0,1-.1.79,3.3,3.3,0,0,1-2.13.85c.15.72.42,2,.62,2.66a1.09,1.09,0,0,1-.16,1C205.44,286.28,204.12,286.31,203.86,286.31Zm9.88-14.85a27.82,27.82,0,0,0-7.07,1c-1.13.31-4.16,1.47-4.7,3.07s1.33,7.33,2.23,9.82a1.85,1.85,0,0,0,1-.3c-.3-1.12-.73-3.28-.75-3.37a.51.51,0,0,1,.09-.41.54.54,0,0,1,.37-.19,4,4,0,0,0,1.93-.47c-.31-.8-1.31-4.94-1.35-5.12a.5.5,0,0,1,.27-.57c.32-.15,7.91-3.61,12.47-2.24l.47.13C217.84,271.79,215.88,271.46,213.74,271.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.85,286.09l2-.28A3.23,3.23,0,0,0,201.85,286.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.85,286.59a.51.51,0,0,1-.48-.33.53.53,0,0,1,.22-.6,3.77,3.77,0,0,1,2.37-.34.5.5,0,0,1,.4.51.49.49,0,0,1-.43.48l-2,.28Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/School.3e2fd5feea7ae4e09530c73c7d7ae5ee.svg";
export { ForwardRef as ReactComponent };